// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-04T23:47:19.865Z
// Property: Birchwood Homes (ID: 6767906449167175)
// Collections: 19 amenities, 10 floorplans (live), 17 photos, 74 POIs, 2 reviews, 1 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, floorplans_full, special_offers, fees

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167175",
  "property_external_id": "1424494",
  "property_zillow_url": "https://www.zillow.com/apartments/fairbanks-ak/birchwood-homes/5XrXRR/",
  "property_apartments_url": "https://www.apartments.com/birchwood-homes-fairbanks-ak/ejzys3q/",
  "property_google_business_url": "https://www.google.com/maps/place/Birchwood/data=!4m2!3m1!1s0x0:0xf5856cee32eb7c64?sa=X&ved=2ahUKEwiLp_yw6YOTAxU4nGoFHRP4N_kQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "birchwood",
  "property_name": "Birchwood Homes",
  "property_website_url": "https://www.birchwoodhomesak.com",
  "property_domain": "https://www.birchwoodhomesak.com",
  "property_address": "1066 Turnagin Loop",
  "property_full_address": "1066 Turnagin Loop, Fairbanks, AK 99701",
  "property_address_1": "1066 Turnagin Loop",
  "property_address_2": null,
  "property_address_city": "Fairbanks",
  "property_address_state": "AK",
  "property_address_zip_full": "99701",
  "property_address_zip": "99701",
  "property_address_country": "US",
  "property_address_county": "Fairbanks North Star Borough",
  "property_neighborhood_address": "Alaska Regional",
  "property_address_latitude": "64.8410719",
  "property_address_longitude": "-147.6577792",
  "property_email": "birchwood@Weidner.com",
  "property_phone": "(907) 531-5282",
  "property_call_tracking_phone": "907-531-5282",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Birchwood in Fairbanks, AK, find spacious three, four, and five-bedroom floor plans designed for comfort. Enjoy amenities like tennis and basketball courts, jogging paths, and tot lots. Our smoke-free community features heated entries and large closets, ensuring your perfect home awaits. Schedule a tour and embrace your new lifestyle today!",
  "property_long_description": "Welcome to Birchwood, your ideal apartment community nestled in the heart of Fairbanks, AK. Our diverse range of spacious floor plans includes Three, Four, and Five Bedroom options, ensuring the perfect fit for you and your family. Each apartment is thoughtfully designed for comfort and convenience, featuring large closets, a dishwasher, and a dedicated washer and dryer area with hook-ups. \n\nExperience the great outdoors right at your doorstep! Birchwood offers fantastic amenities, including two tennis courts, basketball courts, and an extensive jogging path for fitness enthusiasts. Families will love our playground and 17 tot lots, providing a safe and fun environment for children to thrive. For added peace of mind, we provide on-site maintenance and management, ensuring a hassle-free living experience.\n\nOur apartments are built with your comfort in mind, featuring smoke-free living, heated arctic entry areas that minimize heat loss in the winter, and 12-inch thick insulated double walls to keep you cozy all year round. Enjoy the luxury of private cedar deck porches both front and back, perfect for relaxing after a long day. Plus, we offer curbside pick-up for refuse, making disposal effortless for residents.\n\nDon't miss out on the opportunity to become a part of our vibrant community. Find your new home at Birchwood today—browse our availability or schedule a tour to experience the quality of life we offer! Your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-35d9-7497-96fd-0c73409e03dd.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with a sofa, armchair, coffee table, and lamps.",
    "public_id": "019d021c-35d9-7497-96fd-0c73409e03dd",
    "storage_key": "property/6767906449167175/019d021c-35d9-7497-96fd-0c73409e03dd.webp",
    "width": 1536,
    "height": 1024
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "400",
  "property_year_built": "1986",
  "property_year_renovated": null,
  "property_walk_score": "23",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.5",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $1,800",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://birchwoodhomesak.securecafe.com/onlineleasing/birchwood-homes-0/floorplans.aspx",
  "property_resident_portal_url": "https://birchwoodhomesak.securecafenet.com/residentservices/birchwood-homes-0/userlogin",
  "property_apply_now_url": "https://birchwoodhomesak.securecafe.com/onlineleasing/birchwood-homes-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a1410f-1f75-70a9-965c-8c9d176116cc.webp",
  "property_primary_logo_media": {
    "alt_text": "Birchwood Homes logo",
    "public_id": "01a1410f-1f75-70a9-965c-8c9d176116cc",
    "storage_key": "property/6767906449167175/01a1410f-1f75-70a9-965c-8c9d176116cc.webp",
    "width": 581,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a1410f-6fe2-732e-bd46-ffeb1deb45dd.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a1410f-6fe2-732e-bd46-ffeb1deb45dd",
    "storage_key": "property/6767906449167175/01a1410f-6fe2-732e-bd46-ffeb1deb45dd.webp",
    "width": 581,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a1410f-5914-741d-aaa5-6825cf2d3d08.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a1410f-5914-741d-aaa5-6825cf2d3d08",
    "storage_key": "property/6767906449167175/01a1410f-5914-741d-aaa5-6825cf2d3d08.webp",
    "width": 581,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#8B7355",
  "property_secondary_color": "#F5F0E8",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#2C3B2D",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3 - 5",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "5",
  "property_bathrooms_range": "2.5 - 2.5",
  "property_bathrooms_min": "2.5",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "1860 - 2185",
  "property_sqft_min": "1860",
  "property_sqft_max": "2309",
  "property_price_range": "2195 - 2990",
  "property_price_min": "2195",
  "property_price_max": "2990",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/birchwoodhomes",
  "property_instagram_url": "https://www.instagram.com/weidnerapartmenthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJf9RJnfNPMlERZHzrMu5shfU",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Spacious Apartments in Fairbanks",
  "property_home_romance_title": "Welcome to Birchwood",
  "property_home_amenities_blurb": "At Birchwood in Fairbanks, AK, find your perfect fit with spacious three, four, and five-bedroom apartments. Enjoy our top-notch amenities including tennis courts, extensive jogging paths, and playgrounds. Cozy up to winter with heated entryways and relax on cedar deck porches. Experience comfortable living tailored for you and your family!",
  "property_home_floorplans_blurb": "At Birchwood in Fairbanks, AK, our thoughtfully designed floor plans cater to your unique lifestyle. With modern amenities and stunning views, each apartment home invites comfort and convenience. Browse our available apartments today to discover the ideal layout that fits your vision of home sweet home.",
  "property_home_gallery_blurb": "At Birchwood in Fairbanks, AK, spacious three-to-five-bedroom apartments offer a harmonious blend of comfort and style. Enjoy exceptional amenities like two tennis courts, extensive jogging paths, and a smoke-free environment. Picture yourself relaxing on your cedar deck or letting kids explore 17 tot lots, all within a vibrant community!",
  "property_home_neighborhood_blurb": "<p>Step out your front door and discover all that Fairbanks, AK, has to offer. Living at Birchwood puts you minutes from Steese and Richardson Highways, making it easy to run errands at Bentley Mall or Costco. Unwind at local spots like The Crepery or Blue Roof Bistro, or explore nature at Creamer's Field or soak in Chena Hot Springs. Enjoy every season from a community that puts you close to everything you love.</p>",
  "property_home_reviews_blurb": "At Birchwood in Fairbanks, AK, residents cherish the sense of community and warmth. One resident notes, \"I've never felt more at home!\" Join a vibrant neighborhood where comfort meets convenience. Dive into our reviews and see what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "<p>Find your place in Fairbanks' Hamilton Acres neighborhood at Birchwood Homes. Located at 1066 Turnagain Loop, you're never far from adventure, shopping, or a savory meal. Quick access to Steese and Richardson Highways gives you easy access to all of Fairbanks, including short drives to Bentley Mall, Costco, or Fred Meyer. Weekends might take you dog sledding, relaxing at Chena Hot Springs, or visiting iconic spots like the Santa Claus House in North Pole. For food, enjoy nearby favorites such as Lavelle's Bistro and The Crepery, or take a nature walk at Creamer's Field. Immerse yourself in the Fairbanks lifestyle while enjoying the convenience of city living from the comfort of home.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Birchwood in Fairbanks, AK, every home is built for both comfort and durability. Enjoy in-home touches like 12-inch-thick insulated walls, cedar porches, and arctic entry areas that help you make the most of every season. Head outside to tennis and basketball courts, strolling paths, and on-site playgrounds, all designed for easy gathering and relaxing.</p>",
  "property_applynow_blurb": "Welcome to Birchwood in Fairbanks, AK, where spacious three, four, and five-bedroom apartments meet a lifestyle of comfort. Enjoy on-site amenities like tennis courts and an extensive jogging path, all within a smoke-free community designed for warmth and convenience. Lease your new home online today!",
  "property_contactus_blurb": "<p>Reach out to our Birchwood team in Fairbanks, AK, to learn more, ask questions, or arrange a tour. We're here to help you find the right fit among our three-, four-, and five-bedroom homes, whether you'd like to connect online or in person.</p>",
  "property_faqs_blurb": "At Birchwood in Fairbanks, AK, you'll find spacious three, four, and five-bedroom floor plans tailored for your lifestyle. Curious about our community? Dive into our FAQs page for valuable insights and clarity, ensuring you have all the answers before making Birchwood your home sweet home.",
  "property_floorplans_blurb": "<p>Birchwood Homes offers the space you need with three-, four-, and five-bedroom layouts designed for comfort and style. Enjoy open living areas, oversized closets, plenty of storage, and features like triple-pane windows and a private patio or balcony. Work, relax, and gather easily in homes built for Alaska living, complete with an insulated attached garage.</p>",
  "property_gallery_blurb": "<p>Imagine your days at Birchwood as you scroll through our gallery. Picture light-filled rooms with oversized closets, expansive layouts built for comfort, and extra touches like triple-pane windows. Browse community features, from green playgrounds to the wide jogging path. Ready to see more? Schedule a visit to experience the details in person.</p>",
  "property_interactivemap_blurb": "Experience the charm of Birchwood in Fairbanks, AK, where spacious three, four, and five-bedroom apartments await. Enjoy unmatched amenities like tennis and basketball courts, scenic jogging paths, and a smoke-free environment. Explore our interactive community map to find your ideal home, complete with heated entry and ample storage options!",
  "property_pets_blurb": "At Birchwood, where cozy living meets the wild beauty of Fairbanks, your furry companions are embraced. With no weight limits on dogs and a warm welcome for cats, this pet-friendly community invites you to create unforgettable memories together. Enjoy life surrounded by nature—your pets will love it here!",
  "property_referafriend_blurb": "At Birchwood in Fairbanks, AK, spacious three-, four-, and five-bedroom floor plans offer the perfect blend of comfort and style. Great friends make great neighbors—refer a friend to our welcoming community today and enjoy the warmth of shared experiences in your new home. ",
  "property_residentaccess_blurb": "Nestled in the heart of Fairbanks, Birchwood offers spacious three-, four-, and five-bedroom apartments designed for modern living. Elevate your resident experience by logging into your portal—pay rent, schedule maintenance, and connect with your community effortlessly. Welcome home to Birchwood, where comfort meets convenience!",
  "property_reviews_blurb": "At Birchwood in Fairbanks, AK, residents cherish the welcoming atmosphere and stunning views. One happy tenant raved, “The friendly community and spacious apartments make this place feel like home.” See what our residents have to say about living at our community and find your perfect haven today!",
  "property_created_at": "1771536125705",
  "property_scheduletour_blurb": "<p>Ready to get a closer look at your next home? At Birchwood, you can tour in person or connect virtually with our leasing team for a live online tour. Take your time as you walk through three-, four-, and five-bedroom homes, see private patios, and discover community spaces like sports courts and a lively playground. Flexible options help you tour your way, hassle-free.</p>",
  "property_thankyou_blurb": "Thank you for reaching out! At Birchwood in Fairbanks, AK, our spacious three, four, and five-bedroom floor plans offer the perfect blend of comfort and style, tailored for modern living. Stay tuned—we'll be in touch soon to help you find your ideal home!",
  "property_virtualtours_blurb": "<p>A virtual tour at Birchwood Homes makes it simple to imagine yourself living in Fairbanks, AK. Walk through inviting layouts, take in the natural light, and get a feel for the community vibe without leaving your home. See how each space is designed for comfort and get inspired for your next move, all with just a click. Tour your way, anytime and anywhere.</p>",
  "property_copyright": "2026 All Rights Reserved. Birchwood",
  "property_seo_title_home": "Spacious Homes | Birchwood | Fairbanks, AK",
  "property_seo_description_home": "Discover comfort and community at Birchwood Homes - pet-friendly living near downtown Fairbanks, AK, with access to the best dining and shopping.",
  "property_seo_title_floorplans": "Floor Plans | Birchwood | Fairbanks, AK",
  "property_seo_description_floorplans": "Explore spacious 3-, 4-, and 5-bedroom floor plans with private patios and insulated garages at Birchwood in Fairbanks, AK.",
  "property_seo_title_amenities": "Amenities | Birchwood | Fairbanks, AK",
  "property_seo_description_amenities": "Enjoy amenities like insulated garages, front/back cedar porches, sports courts, and arctic entries at Birchwood in Fairbanks, AK.",
  "property_seo_title_gallery": "Photo Gallery | Birchwood | Fairbanks, AK",
  "property_seo_description_gallery": "Picture life at Birchwood in Fairbanks, AK. Browse photos of large layouts, sunlit rooms, and community spaces.",
  "property_seo_title_virtualtours": "Virtual Tour | Birchwood | Fairbanks, AK",
  "property_seo_description_virtualtours": "Take a virtual tour of Birchwood Homes in Fairbanks, AK, and imagine your next chapter with flexible layouts and a welcoming community.",
  "property_seo_title_interactivemap": "Interactive Map | Birchwood Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Birchwood, Fairbanks! Spacious 3-5 bedroom apartments with premium amenities. Check our interactive map for details!",
  "property_seo_title_neighborhood": "Hamilton Acres | Birchwood | Fairbanks, AK",
  "property_seo_description_neighborhood": "Discover the Birchwood Homes neighborhood in Fairbanks, AK - near parks, highways, shopping, dining, and local landmarks.",
  "property_seo_title_contact": "Contact Birchwood Homes | Fairbanks, AK",
  "property_seo_description_contact": "Connect with the Birchwood Homes leasing team in Fairbanks, AK. Get details or schedule your personal tour today.",
  "property_seo_title_faqs": "FAQs | Apartments in Fairbanks, AK",
  "property_seo_description_faqs": "Discover Birchwood in Fairbanks, AK! Visit our FAQs for details on spacious floor plans, amenities, and community life. Get your answers today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Fairbanks, AK",
  "property_seo_description_reviews": "Join Birchwood's vibrant community in Fairbanks, AK! Read resident reviews and discover spacious floor plans, top-notch amenities, and a welcoming atmosphere.",
  "property_seo_title_applynow": "Apply Now | Apartments in Fairbanks, AK",
  "property_seo_description_applynow": "Discover spacious Birchwood in Fairbanks, AK! Choose from 3-5 bedroom layouts with top amenities. Lease your new home online today!",
  "property_seo_title_residentaccess": "Resident Access | Birchwood",
  "property_seo_description_residentaccess": "Unlock your Birchwood experience! Log in to your resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Birchwood",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Birchwood in Fairbanks, AK, and enjoy the perks of community living together. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Birchwood | Fairbanks, AK",
  "property_seo_description_scheduletour": "Tour Birchwood Homes in Fairbanks, AK, in person or online. Choose from guided or virtual tour options to fit your schedule.",
  "property_seo_title_privacy": "Privacy Policy | Birchwood",
  "property_seo_description_privacy": "Your privacy matters at Birchwood in Fairbanks, AK. Learn how we protect your information and ensure a secure living experience. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Birchwood",
  "property_seo_description_accessibility": "At Birchwood in Fairbanks, AK, we promote digital inclusivity with accessible features, ensuring everyone feels at home. Join our welcoming community!",
  "property_seo_title_sitemap": "Sitemap | Birchwood",
  "property_seo_description_sitemap": "Unlock the full potential of Birchwood in Fairbanks, AK! Navigate easily through our sitemap and find everything you need for your perfect home.",
  "property_seo_title_thankyou": "Thank You | Birchwood",
  "property_seo_description_thankyou": "Thank you for reaching out to Birchwood in Fairbanks, AK! One of our friendly team members will connect with you soon. Your future home awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Fairbanks, AK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793654764137",
  "amenities": [
    {
      "id": "ec_c3f9c647ae7682e79591a783",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355138",
      "title": "Temperature controlled insulated garage with electric garage door opener with remote control.",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_edb8749960e030afec89c331",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355141",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d56c15c6eaf08b387cb2dc55",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355136",
      "title": "Two Tennis courts",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce2e879ebe55ca14d730ba7f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355145",
      "title": "Basketball courts",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_662f60c2b325005e7dfc0b6f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355139",
      "title": "On-site maintenance and management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_633a7f6d88dfa777a3d6fec5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355150",
      "title": "Washer and dryer area with hook ups",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6265ed85aac92fd19b38e0c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355152",
      "title": "Space allows for an extra refrigerator or freezer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e8b347943a09e5012b6db796",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355162",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30cbdbb26775336ff60e27db",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355158",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_858badab87c07a6bdf6eeb96",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355166",
      "title": "Heated arctic entry area for comfort to reduce loss of heat in the winter",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9f26cb2a864e2e85c24cbce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355137",
      "title": "The streets, buildings and even the interiors are laid out to fully utilize the sunlight",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_94b59e8f863222c9631be4bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355168",
      "title": "12 inch thick insulated double walls.",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fe36b9b6afeb5547a1bd5b5b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355143",
      "title": "Home interiors are creatively designed to accommodate your greater indoor needs during the winter months.",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41f0e5de1dac195b8fcbe096",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355148",
      "title": "17 Tot lots",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e8d08eab864859c65fd85f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355153",
      "title": "Sink disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_32686d3c7731ba52b0fba7f5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355164",
      "title": "Cedar deck porches both front and back",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a966295c508451a9da17343a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355146",
      "title": "An extensive jogging path",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-93f1-7717-bdef-3a70968df0e0.webp",
      "amenity_image_media": {
        "alt_text": "Townhouse style apartments with garages under a cloudy sky",
        "public_id": "019d021c-93f1-7717-bdef-3a70968df0e0",
        "storage_key": "property/6767906449167175/019d021c-93f1-7717-bdef-3a70968df0e0.webp",
        "width": 725,
        "height": 483
      },
      "amenity_image_alt_text": "Birchwood Homes Apartments - Exterior",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8b11a469887fb21fa8467671",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "89355163",
      "title": "Curbside pick up service for refuse",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_631b18da3a002de00f160af1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "124800146",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_3592c99a35b932d4f2aa81db",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-35d9-7497-96fd-0c73409e03dd.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and lamps.",
        "public_id": "019d021c-35d9-7497-96fd-0c73409e03dd",
        "storage_key": "property/6767906449167175/019d021c-35d9-7497-96fd-0c73409e03dd.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living area with comfortable seating, perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "A spacious living room at Birchwood Apartments featuring matching gray sofas and an armchair with neutral pillows. Two framed artworks hang above the main couch, and end tables with lamps flank the seating. A wooden coffee table and a tall potted plant complete the warm, inviting space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Birchwood_Favorites%20(1).jpg"
    },
    {
      "id": "ec_baea69faff220f625e4e55b2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a037a1-3bc4-72cb-9e6a-6b1d3744d1df.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and artwork.",
        "public_id": "01a037a1-3bc4-72cb-9e6a-6b1d3744d1df",
        "storage_key": "property/6767906449167175/01a037a1-3bc4-72cb-9e6a-6b1d3744d1df.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "A beautifully appointed living room featuring a plush sofa, comfortable armchairs, a stylish coffee table, and decorative artwork, creating a welcoming and elegant space.",
      "link": "false",
      "alt_text": "A bright living room at Birchwood Apartments with a tufted sofa, two upholstered high-back chairs, and a round glass coffee table on a patterned area rug. Wall art, accent pillows, and floor lamps add color and warmth, while two windows bring in natural light from outside.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Birchwood_Favorites%20(28).jpg"
    },
    {
      "id": "ec_623151c51e7ef055ed2576b0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a037a1-3fa9-71ee-8a12-5fa25d26b376.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment showing a dining area with a table and chairs, leading to a living room.",
        "public_id": "01a037a1-3fa9-71ee-8a12-5fa25d26b376",
        "storage_key": "property/6767906449167175/01a037a1-3fa9-71ee-8a12-5fa25d26b376.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Step into this inviting apartment, featuring a cozy dining nook and a spacious living area perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "A cozy dining nook at Birchwood Apartments featuring a round glass table with two cushioned chairs set against a dividing wall decorated with a vintage key-shaped wall clock, with views into the adjoining living room and hallway lined with windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Birchwood_Favorites%20(34).jpg"
    },
    {
      "id": "ec_e68cc4161ea961a2ebb5109f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a037a1-3fb2-7228-8d2d-36d322a83254.webp",
      "image_media": {
        "alt_text": "Dining room and living room area with furniture, view into kitchen.",
        "public_id": "01a037a1-3fb2-7228-8d2d-36d322a83254",
        "storage_key": "property/6767906449167175/01a037a1-3fb2-7228-8d2d-36d322a83254.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Expansive dining and living room area, complete with elegant furnishings and a glimpse into the modern kitchen. Perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Dining area at Birchwood Apartments featuring a dark wood table set for four with woven placemats and folded napkins, opening into a cozy living room with upholstered seating, floral artwork, and large windows letting in natural light.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Birchwood_Favorites%20(29).jpg"
    },
    {
      "id": "ec_5f6284130ae3a92b44190868",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-4081-767f-8f72-7dc9e3248ee2.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with a table set for four.",
        "public_id": "019d021c-4081-767f-8f72-7dc9e3248ee2",
        "storage_key": "property/6767906449167175/019d021c-4081-767f-8f72-7dc9e3248ee2.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A functional kitchen and dining area, perfect for preparing meals and enjoying them with friends and family.",
      "link": "false",
      "alt_text": "Dining space at Birchwood Apartments featuring a wooden table set for four with rolled napkins, opening to a spacious kitchen with light cabinetry, long countertops, and modern appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Birchwood_Favorites%20(5).jpg"
    },
    {
      "id": "ec_6569817e1b030180be4c54d2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-43c2-721b-b162-f92edf319826.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, blue countertops, double sink, stove, and refrigerator.",
        "public_id": "019d021c-43c2-721b-b162-f92edf319826",
        "storage_key": "property/6767906449167175/019d021c-43c2-721b-b162-f92edf319826.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample cabinet space, a double sink, a full-sized refrigerator, and a stove. Perfect for all your cooking needs.",
      "link": "false",
      "alt_text": "Birchwood kitchen with L-shaped light cabinetry, blue countertops, white appliances, and simple décor including fruit, jars, and a coffee maker.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Birchwood_Favorites%20(6).jpg"
    },
    {
      "id": "ec_a1991e3895c48e8e84fd6c20",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a037a1-3c9f-7652-9fd6-da320ec76058.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel appliances including a refrigerator and stove, and a double sink.",
        "public_id": "01a037a1-3c9f-7652-9fd6-da320ec76058",
        "storage_key": "property/6767906449167175/01a037a1-3c9f-7652-9fd6-da320ec76058.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring ample cabinet space, a dishwasher, a stove with an overhead vent, and a double sink. Perfect for everyday cooking.",
      "link": "false",
      "alt_text": "Birchwood kitchen with cream and wood cabinets, pink countertops, stainless steel appliances, and a window above the sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Birchwood_Favorites%20(27).jpg"
    },
    {
      "id": "ec_df8e70a4e4d99108952f42ee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-4483-7733-9205-f3d60778c052.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and closet.",
        "public_id": "019d021c-4483-7733-9205-f3d60778c052",
        "storage_key": "property/6767906449167175/019d021c-4483-7733-9205-f3d60778c052.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed with blue and white linens, a wooden headboard, and a nightstand with a lamp. Includes a dresser and a closet for ample storage.",
      "link": "false",
      "alt_text": "A cozy Birchwood bedroom featuring a wooden bed frame with paneled headboard, dressed in crisp white bedding accented with blue trim and patterned throw pillows. A warm lamp sits on the matching nightstand beside a framed photo. The room includes soft carpet, an open closet with sliding doors, and a doorway leading to the hall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Birchwood_Favorites%20(8).jpg"
    },
    {
      "id": "ec_c177857f63c141608cea1b87",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a037a1-55fa-744b-92c6-3fee7215bcb4.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a closet.",
        "public_id": "01a037a1-55fa-744b-92c6-3fee7215bcb4",
        "storage_key": "property/6767906449167175/01a037a1-55fa-744b-92c6-3fee7215bcb4.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a comfortable queen-size bed, two wooden nightstands with lamps, and a large closet with sliding doors.",
      "link": "false",
      "alt_text": "A bright Birchwood bedroom featuring a dark upholstered headboard with paisley bedding and layered pillows centered against a neutral wall. Two matching lamps on wooden nightstands sit beside the bed beneath twin windows. The room includes soft carpet and a wide closet with sliding wooden doors partially open.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Birchwood_Favorites%20(30).jpg"
    },
    {
      "id": "ec_662c021fbf2e169ac86b9d0c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a037a1-768b-742b-ac50-5ca9265d9864.webp",
      "image_media": {
        "alt_text": "Bedroom with a twin bed, dresser, and closet.",
        "public_id": "01a037a1-768b-742b-ac50-5ca9265d9864",
        "storage_key": "property/6767906449167175/01a037a1-768b-742b-ac50-5ca9265d9864.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable twin bed, ample storage with a dresser and closet, and natural light from the windows.",
      "link": "false",
      "alt_text": "A cheerful Birchwood bedroom with soft beige walls and carpet, featuring a white twin bed with storage drawers and bright pink bedding topped with playful accent pillows. Two windows let in natural light above floral wall art. A matching nightstand with a lamp and a coordinating dresser complete the cozy space beside a wide closet with sliding wooden doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Birchwood_Favorites%20(31).jpg"
    },
    {
      "id": "ec_523196292ff4770571845cac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a037a1-7521-73c6-a2c2-829b89011e87.webp",
      "image_media": {
        "alt_text": "Interior hallway with doors to bedrooms and a closet.",
        "public_id": "01a037a1-7521-73c6-a2c2-829b89011e87",
        "storage_key": "property/6767906449167175/01a037a1-7521-73c6-a2c2-829b89011e87.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Hallway leading to bedrooms and a closet. This image shows the interior layout and living spaces available.",
      "link": "false",
      "alt_text": "A clean Birchwood hallway with soft carpet and warm wood trim leading to multiple bedrooms. The landing features a built-in shelving niche with sliding closet doors and openings to rooms lit by natural light. A wooden handrail lines the staircase edge, and glimpses of neutral walls and simple finishes create a tidy, open transition space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Birchwood_Favorites%20(33).jpg"
    },
    {
      "id": "ec_bf17e4bcae4540356155822d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-4f81-7335-bc5c-32aa38a05faa.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, toilet, and vanity",
        "public_id": "019d021c-4f81-7335-bc5c-32aa38a05faa",
        "storage_key": "property/6767906449167175/019d021c-4f81-7335-bc5c-32aa38a05faa.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub, toilet, and vanity with ample counter space.",
      "link": "false",
      "alt_text": "A tidy Birchwood bathroom featuring a white bathtub with a bold navy and white striped shower curtain. A compact vanity with a blue countertop and single sink sits beneath a wide mirror. Soft towels hang on the wall, and open shelving stocked with neatly rolled linens adds simple, useful storage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Birchwood_Favorites%20(12).JPG"
    },
    {
      "id": "ec_b25029f7a5b4f1adab971a7c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-569a-76a5-b9b2-b402599f9838.webp",
      "image_media": {
        "alt_text": "Washer and dryer next to an open bathroom door revealing a bathtub and shower",
        "public_id": "019d021c-569a-76a5-b9b2-b402599f9838",
        "storage_key": "property/6767906449167175/019d021c-569a-76a5-b9b2-b402599f9838.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer set located next to a bathroom with a bathtub and shower.",
      "link": "false",
      "alt_text": "A functional Birchwood laundry nook featuring a white top-load washer and dryer tucked behind sliding wooden doors, with the bathroom just steps away. The adjoining bath includes a tub with a bold navy and white striped shower curtain, creating a practical and organized household layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Birchwood_Favorites%20(13).jpg"
    },
    {
      "id": "ec_90f9560cdbf735d7523d803b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-5847-7070-8a6c-110ebbadcdcd.webp",
      "image_media": {
        "alt_text": "Laundry room with stacked washer and dryer",
        "public_id": "019d021c-5847-7070-8a6c-110ebbadcdcd",
        "storage_key": "property/6767906449167175/019d021c-5847-7070-8a6c-110ebbadcdcd.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry room featuring a stacked washer and dryer for your ease and comfort.",
      "link": "false",
      "alt_text": "A simple Birchwood laundry room with a front-loading washer and dryer placed side by side at the end of a narrow nook. Soft neutral walls and overhead lighting brighten the compact space, while a patterned rug adds a touch of comfort beneath the appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Birchwood_Favorites%20(14).jpg"
    },
    {
      "id": "ec_da41a3b54a180ec9cfb998c0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-5a2e-73da-86b0-4f682b5595b2.webp",
      "image_media": {
        "alt_text": "Interior of a clean, empty garage with a closed garage door.",
        "public_id": "019d021c-5a2e-73da-86b0-4f682b5595b2",
        "storage_key": "property/6767906449167175/019d021c-5a2e-73da-86b0-4f682b5595b2.webp",
        "width": 380,
        "height": 275
      },
      "title": "Community",
      "description": "An empty, clean, and well-lit garage with a white garage door and a small window.",
      "link": "false",
      "alt_text": "A clean Birchwood garage with freshly painted pale blue floors and bright white walls, offering a tidy single-car space beneath overhead lighting. A small window brings natural light into the room, while a black utility bin sits neatly near the closed garage door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Birchwood_Favorites%20(15).jpg"
    },
    {
      "id": "ec_7eed40733d66bf94ff74f986",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-5e71-7203-bb0c-3ed9562ffa33.webp",
      "image_media": {
        "alt_text": "Exterior of a townhome with a garage and a driveway.",
        "public_id": "019d021c-5e71-7203-bb0c-3ed9562ffa33",
        "storage_key": "property/6767906449167175/019d021c-5e71-7203-bb0c-3ed9562ffa33.webp",
        "width": 1148,
        "height": 765
      },
      "title": "Community",
      "description": "Exterior view of a townhome, showcasing its architecture, private garage, and driveway access.",
      "link": "false",
      "alt_text": "A well-kept Birchwood townhome exterior featuring a tan two-story façade with gray trim, a single-car garage, and a small covered entryway with a white front door. The freshly paved driveway and green lawn frame the home, while a tree and bright summer skies add curb appeal and a welcoming neighborhood feel.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Birchwood_Favorites%20(16).jpg"
    },
    {
      "id": "ec_1e2dec88c8f6d3610955650e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-639b-70aa-bb1b-0fddbd3aee19.webp",
      "image_media": {
        "alt_text": "Exterior of a green apartment building with an attached garage on a sunny day.",
        "public_id": "019d021c-639b-70aa-bb1b-0fddbd3aee19",
        "storage_key": "property/6767906449167175/019d021c-639b-70aa-bb1b-0fddbd3aee19.webp",
        "width": 1148,
        "height": 765
      },
      "title": "Community",
      "description": "A charming green apartment building with an attached garage, set against a backdrop of green lawns and a cloudy sky. Perfect for those seeking a comfortable and convenient living space.",
      "link": "false",
      "alt_text": "A bright Birchwood townhome with a sage-green exterior, attached single-car garage, and covered entryway sits on a wide open lawn under partly cloudy skies. Multiple vertical windows line the façade, and a small flower planter frames the front steps, giving the home a tidy and inviting curb appeal.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AK_Birchwood_Favorites%20(17).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_c6b55611-a901-477d-a28f-8f736255f395",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "The Cookie Jar Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1006 Cadillac Ct, Fairbanks, AK 99701, USA",
      "poi_short_description": "Relaxed restaurant & bakery serving up all-day breakfast, soups & sandwiches, plus steak & seafood.",
      "poi_long_description": "Relaxed restaurant & bakery serving up all-day breakfast, soups & sandwiches, plus steak & seafood.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14111-0e8b-7329-ba61-6163e2abb18d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14111-0e8b-7329-ba61-6163e2abb18d",
        "storage_key": "property/6767906449167175/01a14111-0e8b-7329-ba61-6163e2abb18d.webp",
        "width": 590,
        "height": 317
      },
      "poi_business_url": "http://cookiejarfairbanks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10607641450905047798&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-cookie-jar-restaurant",
      "poi_latitude": "64.8546238",
      "poi_longitude": "-147.747315",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-479-8319",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20d3-756e-87fb-39e8de052830",
        "storage_key": "property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ebVISVFMlER9pLnqbLpNZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_b93c9522-0b36-401f-a0c3-1310a94c626a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "River City Cafe",
      "poi_type": "Restaurants",
      "poi_address": "535 2nd Ave Ste 101, Fairbanks, AK 99701, USA",
      "poi_short_description": "Cozy cafe offering specialty coffee and breakfast staples like biscuits and gravy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-6393-716a-a442-fc92498b3bf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-6393-716a-a442-fc92498b3bf4",
        "storage_key": "property/6767906449167175/01a14113-6393-716a-a442-fc92498b3bf4.webp",
        "width": 1280,
        "height": 1235
      },
      "poi_business_url": "http://www.rivercitycafefairbanks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9483522539189247602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-city-cafe",
      "poi_latitude": "64.84330729999999",
      "poi_longitude": "-147.7200282",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-456-6242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20cf-7416-b146-528812fa6955.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20cf-7416-b146-528812fa6955",
        "storage_key": "property/6767906449167175/019d021d-20cf-7416-b146-528812fa6955.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ3al280hFMlERch7J54A9nIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_cce64c49-6e78-41a7-8e18-187189ac1bac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Bucko's Coffee",
      "poi_type": "Restaurants",
      "poi_address": "281 Bentley Trust Rd, Fairbanks, AK 99701, USA",
      "poi_short_description": "Popular coffee hut serving specialty drinks and breakfast food.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-a34a-7458-9388-1c68797d55a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-a34a-7458-9388-1c68797d55a3",
        "storage_key": "property/6767906449167175/019d021c-a34a-7458-9388-1c68797d55a3.webp",
        "width": 768,
        "height": 960
      },
      "poi_business_url": "https://www.buckoscoffee-ak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=94575795132229362&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buckos-coffee",
      "poi_latitude": "64.8542102",
      "poi_longitude": "-147.7120363",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20cf-7416-b146-528812fa6955.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20cf-7416-b146-528812fa6955",
        "storage_key": "property/6767906449167175/019d021d-20cf-7416-b146-528812fa6955.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJh_zihT9FMlER8uY0QS8AUAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_b9f80dd6-dd6e-4220-9fe5-e0da68f9fe43",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Bagels & Brew",
      "poi_type": "Restaurants",
      "poi_address": "36 College Rd #9w, Fairbanks, AK 99701, USA",
      "poi_short_description": "Cafe/bakery chain preparing small-batch, New York-style bagels, plus breakfast & lunch sandwiches.",
      "poi_long_description": "Cafe/bakery chain preparing small-batch, New York-style bagels, plus breakfast & lunch sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-6aaf-713d-b15e-72a8fab7fdc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-6aaf-713d-b15e-72a8fab7fdc5",
        "storage_key": "property/6767906449167175/01a14113-6aaf-713d-b15e-72a8fab7fdc5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bagelsandbrewak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17725183069916086699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bagels--brew",
      "poi_latitude": "64.8513761",
      "poi_longitude": "-147.7048945",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-452-3940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20d3-756e-87fb-39e8de052830",
        "storage_key": "property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBZ74DUFFMlERq8EdDReA_PU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3f4501cc-ad79-4def-980b-bcd5f4ba8da6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Bakery Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "44 College Rd Ste a, Fairbanks, AK 99701, USA",
      "poi_short_description": "Patrons can order breakfast, lunch or dinner fare all day at this casual, old-timey American diner.",
      "poi_long_description": "Patrons can order breakfast, lunch or dinner fare all day at this casual, old-timey American diner.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-6544-765b-baea-a4159f5faeea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-6544-765b-baea-a4159f5faeea",
        "storage_key": "property/6767906449167175/01a14113-6544-765b-baea-a4159f5faeea.webp",
        "width": 1258,
        "height": 790
      },
      "poi_business_url": "https://www.thebakeryrestaurantfairbanks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1402252146313689632&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bakery-restaurant",
      "poi_latitude": "64.8518972",
      "poi_longitude": "-147.7063867",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-456-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20d3-756e-87fb-39e8de052830",
        "storage_key": "property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtVn-gUBFMlERIHqOyuXMdRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_9647dc61-7b8a-4791-8bf4-08220f92d729",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Blue Roof Bistro",
      "poi_type": "Restaurants",
      "poi_address": "13 Timberland Dr, Fairbanks, AK 99701, USA",
      "poi_short_description": "Charming bistro serving elevated comfort food including smoked salmon sliders and hand-cut fries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-a68e-75f9-b7c5-154bd328e59d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-a68e-75f9-b7c5-154bd328e59d",
        "storage_key": "property/6767906449167175/019d021c-a68e-75f9-b7c5-154bd328e59d.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://blueroofbistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17837383254265836042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-roof-bistro",
      "poi_latitude": "64.8486389",
      "poi_longitude": "-147.7007389",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-799-5913",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20d3-756e-87fb-39e8de052830",
        "storage_key": "property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqwHqlENFMlERCjIEMZAdi_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bistro"
    },
    {
      "id": "custom_ef53c389-1d04-4738-83f7-595f2dd2c255",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "The Pump House Restaurant Fairbanks",
      "poi_type": "Restaurants",
      "poi_address": "796 Chena Pump Rd, Fairbanks, AK 99709, USA",
      "poi_short_description": "Surf 'n' turf specialist decorated with gold-rush-era relics & featuring an ornate mahogany bar.",
      "poi_long_description": "Surf 'n' turf specialist decorated with gold-rush-era relics & featuring an ornate mahogany bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-64c8-759a-8e93-d488b4352589.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-64c8-759a-8e93-d488b4352589",
        "storage_key": "property/6767906449167175/01a14113-64c8-759a-8e93-d488b4352589.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pumphouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13063192504970126715&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-pump-house-restaurant-fairbanks",
      "poi_latitude": "64.83130919999999",
      "poi_longitude": "-147.8847474",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-479-8452",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20d3-756e-87fb-39e8de052830",
        "storage_key": "property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbf5SBnJbMlEReyVKG1_ISbU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_e0a1d0f9-d792-45e9-8bf5-1228641827e0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Geraldo's Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "701 College Rd, Fairbanks, AK 99701, USA",
      "poi_short_description": "Casual eatery offering pizza, pasta dishes & other standard Italian fare, plus beer & wine.",
      "poi_long_description": "Casual eatery offering pizza, pasta dishes & other standard Italian fare, plus beer & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-7026-736a-acbc-180dae58244a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-7026-736a-acbc-180dae58244a",
        "storage_key": "property/6767906449167175/01a14113-7026-736a-acbc-180dae58244a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://geraldositalianrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10756791823157321971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "geraldos-italian-restaurant",
      "poi_latitude": "64.8587568",
      "poi_longitude": "-147.7226239",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-452-2299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20d3-756e-87fb-39e8de052830",
        "storage_key": "property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWaej9D1FMlER82Ae1ivNR5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_a02b2d32-58dc-451a-8c2b-a9fd2e21d896",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Pho Siam Square",
      "poi_type": "Restaurants",
      "poi_address": "59 College Rd #202, Fairbanks, AK 99701, USA",
      "poi_short_description": "Snug Thai eatery serves hefty portions of classic fare in a simple space with an adjoining grocery.",
      "poi_long_description": "Snug Thai eatery serves hefty portions of classic fare in a simple space with an adjoining grocery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-6c38-70c9-b932-36c14c2cc8c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-6c38-70c9-b932-36c14c2cc8c5",
        "storage_key": "property/6767906449167175/01a14113-6c38-70c9-b932-36c14c2cc8c5.webp",
        "width": 1280,
        "height": 949
      },
      "poi_business_url": "https://siamsquarerestaurant.com/?",
      "poi_directions_map_url": "https://maps.google.com/?cid=2019894342688070096&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pho-siam-square",
      "poi_latitude": "64.8522741",
      "poi_longitude": "-147.71226560000002",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-458-7426",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20d3-756e-87fb-39e8de052830",
        "storage_key": "property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWaKMkEBFMlER0Fm-6zMbCBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_1c1443c5-5366-4a0c-8a46-d6144d234315",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Food Factory",
      "poi_type": "Restaurants",
      "poi_address": "275 Bentley Trust Rd, Fairbanks, AK 99701, USA",
      "poi_short_description": "Family-friendly restaurant serving comfort foods like cheesesteaks and burgers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-64db-75da-a0f0-1be2955af597.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-64db-75da-a0f0-1be2955af597",
        "storage_key": "property/6767906449167175/01a14113-64db-75da-a0f0-1be2955af597.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.foodfactoryfbx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6336152748316462970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-factory",
      "poi_latitude": "64.8537826",
      "poi_longitude": "-147.7110443",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-452-3313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20d3-756e-87fb-39e8de052830",
        "storage_key": "property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT_XXBkFFMlEReo8ErlqJ7lc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "family_restaurant"
    },
    {
      "id": "custom_bff65bcc-ed24-45db-af5e-2c306ec52f23",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "The Crepery",
      "poi_type": "Restaurants",
      "poi_address": "523 2nd Ave, Fairbanks, AK 99701, USA",
      "poi_short_description": "Unassuming counter-serve restaurant focusing on sweet & savory crêpes, plus coffee.",
      "poi_long_description": "Unassuming counter-serve restaurant focusing on sweet & savory crêpes, plus coffee.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14111-1230-737d-b232-2c4148c0441b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14111-1230-737d-b232-2c4148c0441b",
        "storage_key": "property/6767906449167175/01a14111-1230-737d-b232-2c4148c0441b.webp",
        "width": 1280,
        "height": 802
      },
      "poi_business_url": "https://thecrepery.net/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=7571400803399729755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-crepery",
      "poi_latitude": "64.8431209",
      "poi_longitude": "-147.7189575",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-450-9192",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-24b2-75c1-abf3-b40b8f60c3f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-24b2-75c1-abf3-b40b8f60c3f3",
        "storage_key": "property/6767906449167175/019d021d-24b2-75c1-abf3-b40b8f60c3f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6_qOHdJaMlERW4K_auoEE2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dessert_shop"
    },
    {
      "id": "custom_a9c1b18c-5af8-4206-a21d-7bb0326f4848",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Latitude 65 Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "150 Eagle Ave Unit b, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-68c0-718d-b91c-6f70241f9556.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-68c0-718d-b91c-6f70241f9556",
        "storage_key": "property/6767906449167175/01a14113-68c0-718d-b91c-6f70241f9556.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.lat65brewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13676930731438179708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "latitude-65-brewing-company",
      "poi_latitude": "64.8453085",
      "poi_longitude": "-147.7005386",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-328-7748",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20b8-7511-9710-25d994c883f8",
        "storage_key": "property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDbXZfWtFMlERfAX_aAk4zr0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_95cd29bd-820e-43c1-b361-0dc9adfcd36f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Ajimi",
      "poi_type": "Restaurants",
      "poi_address": "69 College Rd, Fairbanks, AK 99701, USA",
      "poi_short_description": "Relaxed, neighborhood eatery preparing creative sushi rolls along with other classic Japanese mains.",
      "poi_long_description": "Relaxed, neighborhood eatery preparing creative sushi rolls along with other classic Japanese mains.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-6ab9-767a-83bb-d1fb7fad80de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-6ab9-767a-83bb-d1fb7fad80de",
        "storage_key": "property/6767906449167175/01a14113-6ab9-767a-83bb-d1fb7fad80de.webp",
        "width": 1280,
        "height": 628
      },
      "poi_business_url": "https://www.ajimijapaneserestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8984875750955729072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ajimi",
      "poi_latitude": "64.8526916",
      "poi_longitude": "-147.7133483",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-457-1339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20d3-756e-87fb-39e8de052830",
        "storage_key": "property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo_3Yf09FMlERsMC8PuSwsHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_d073b44c-9aab-49d3-aad2-a5c80f8b8d7a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Asiana Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2001 Airport Way, Fairbanks, AK 99701, USA",
      "poi_short_description": "Quiet Japanese-Korean eatery serving fresh sushi and chicken teriyaki.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-6bc2-7618-ae10-f27c61643352.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-6bc2-7618-ae10-f27c61643352",
        "storage_key": "property/6767906449167175/01a14113-6bc2-7618-ae10-f27c61643352.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14296671299893360682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asiana-restaurant",
      "poi_latitude": "64.8360539",
      "poi_longitude": "-147.76238519999998",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-457-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20d3-756e-87fb-39e8de052830",
        "storage_key": "property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXcanL8xaMlERKniq3Mz6Z8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_f5411cde-c6b7-4f41-9fed-90fd133c7c89",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Gallo's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "60 College Rd, Fairbanks, AK 99701, USA",
      "poi_short_description": "Mexican restaurant featuring a variety of classic dishes and signature margaritas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-71b7-7279-bae9-366bae072d3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-71b7-7279-bae9-366bae072d3d",
        "storage_key": "property/6767906449167175/01a14113-71b7-7279-bae9-366bae072d3d.webp",
        "width": 1280,
        "height": 894
      },
      "poi_business_url": "http://gallosak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3120615577170325072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gallos-mexican-restaurant",
      "poi_latitude": "64.8538887",
      "poi_longitude": "-147.712455",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-455-9225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20d3-756e-87fb-39e8de052830",
        "storage_key": "property/6767906449167175/019d021d-20d3-756e-87fb-39e8de052830.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ01xPgT9FMlERUK7JbVWnTis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_ce009ab6-6f1e-46f2-8b3d-f111e8bb777d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Speedway Express",
      "poi_type": "Transportation & Transit",
      "poi_address": "99 College Rd, Fairbanks, AK 99701, USA",
      "poi_short_description": "Convenient gas station offering a variety of snacks, coffee, and prepared food.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-74e1-7494-bafd-2bdfc43e0148.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-74e1-7494-bafd-2bdfc43e0148",
        "storage_key": "property/6767906449167175/01a14113-74e1-7494-bafd-2bdfc43e0148.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11169625936255538063&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "speedway-express",
      "poi_latitude": "64.85382489999999",
      "poi_longitude": "-147.7148953",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-456-5482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-ad5d-700d-a750-9eb31d62b0fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14113-ad5d-700d-a750-9eb31d62b0fa",
        "storage_key": "property/6767906449167175/01a14113-ad5d-700d-a750-9eb31d62b0fa.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJX_k45iBFMlERj1OAHJx7Aps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_b62709fa-8296-4dc2-b71c-94a00ffe149d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "575 Harold Bentley Ave, Fairbanks, AK 99701, USA",
      "poi_short_description": "Convenience store supplying gas, prepared food, and coffee, plus late-night eats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-7407-771f-a8e4-f960252aaf70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-7407-771f-a8e4-f960252aaf70",
        "storage_key": "property/6767906449167175/01a14113-7407-771f-a8e4-f960252aaf70.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/fairbanks/575-harold-bentley-ave/2746640?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=8894891261581363950&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "64.8594317",
      "poi_longitude": "-147.6846581",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-451-0030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-ad4f-7471-88e7-6169728e6bbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14113-ad4f-7471-88e7-6169728e6bbc",
        "storage_key": "property/6767906449167175/01a14113-ad4f-7471-88e7-6169728e6bbc.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJWYyIwBRFMlER7opIqnkAcXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_1031ead7-76bb-428d-856a-c2b9fd043b15",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "530 Old Steese Hwy, Fairbanks, AK 99701, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-76d8-7049-b95c-8079a1101357.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-76d8-7049-b95c-8079a1101357",
        "storage_key": "property/6767906449167175/01a14113-76d8-7049-b95c-8079a1101357.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-530+old+steese+hwy-fairbanks-ak-99701/id=15944",
      "poi_directions_map_url": "https://maps.google.com/?cid=14921658360669507550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "64.8508044",
      "poi_longitude": "-147.6970625",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-457-9301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20b8-7511-9710-25d994c883f8",
        "storage_key": "property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ4wYOUJFMlER3o9xfzhhFM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_eed8e4b5-266e-4507-aa74-0a919e6dd818",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "30 College Rd, Fairbanks, AK 99701, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-bcf8-722d-b4ad-f22b73e62a0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-bcf8-722d-b4ad-f22b73e62a0f",
        "storage_key": "property/6767906449167175/019d021c-bcf8-722d-b4ad-f22b73e62a0f.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://local.safeway.com/safeway/ak/fairbanks/30-college-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=1316790043954109580&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "64.85162079999999",
      "poi_longitude": "-147.7007466",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-456-8501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2485-762f-8986-3d019d072a87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2485-762f-8986-3d019d072a87",
        "storage_key": "property/6767906449167175/019d021d-2485-762f-8986-3d019d072a87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ92tUfEFFMlERjNynfZEtRhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5c75419d-3da9-40f0-84f5-fe2add394cf3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Co-op Market Grocery & Deli",
      "poi_type": "Shopping & Retail",
      "poi_address": "526 Gaffney Rd, Fairbanks, AK 99701, USA",
      "poi_short_description": "Community grocery store featuring natural and organic foods and fresh produce.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-7658-73b0-9465-2ed4b4339e3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-7658-73b0-9465-2ed4b4339e3c",
        "storage_key": "property/6767906449167175/01a14113-7658-73b0-9465-2ed4b4339e3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.coopmarket.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3684974574566027869&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "co-op-market-grocery--deli",
      "poi_latitude": "64.8373446",
      "poi_longitude": "-147.7154353",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-457-1023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2485-762f-8986-3d019d072a87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2485-762f-8986-3d019d072a87",
        "storage_key": "property/6767906449167175/019d021d-2485-762f-8986-3d019d072a87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAAExFMlERXbJaC9qoIzM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b9edb1a6-10e9-4496-935b-b587b1e6ec86",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "48 College Rd, Fairbanks, AK 99701, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-7980-7053-ba59-f9c6cd250bf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-7980-7053-ba59-f9c6cd250bf6",
        "storage_key": "property/6767906449167175/01a14113-7980-7053-ba59-f9c6cd250bf6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.costco.com/w/-/ak/fairbanks/1342",
      "poi_directions_map_url": "https://maps.google.com/?cid=12789563378802640227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "64.8529499",
      "poi_longitude": "-147.70833790000003",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-205-3607",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-24b2-75c1-abf3-b40b8f60c3f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-24b2-75c1-abf3-b40b8f60c3f3",
        "storage_key": "property/6767906449167175/019d021d-24b2-75c1-abf3-b40b8f60c3f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDcgHfOdFMlERY0XgiSGofbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_56d91a43-4a20-411c-8058-b233f5fbfb3c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "537 Johansen Expy, Fairbanks, AK 99701, USA",
      "poi_short_description": "Comprehensive department store serving as a one-stop shop for home goods, electronics, and daily essentials.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-c029-75bd-84ae-55be9307970c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-c029-75bd-84ae-55be9307970c",
        "storage_key": "property/6767906449167175/019d021c-c029-75bd-84ae-55be9307970c.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2722-fairbanks-ak/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10828311508139607229&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "64.8565115",
      "poi_longitude": "-147.6898199",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-451-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-24b2-75c1-abf3-b40b8f60c3f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-24b2-75c1-abf3-b40b8f60c3f3",
        "storage_key": "property/6767906449167175/019d021d-24b2-75c1-abf3-b40b8f60c3f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJByCmW2lFMlERvYTvH_LjRZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_7c91c360-527d-424e-ac79-1faf6d16df7f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "930 Old Steese Hwy ste a, Fairbanks, AK 99701, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-c049-74fb-9526-d5ad59eb151a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-c049-74fb-9526-d5ad59eb151a",
        "storage_key": "property/6767906449167175/019d021c-c049-74fb-9526-d5ad59eb151a.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/ak/fairbanks/east-fairbanks/701/00224?cid=loc_70100224_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=18178466701584784905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "64.8547079",
      "poi_longitude": "-147.6904142",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 907-459-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2485-762f-8986-3d019d072a87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2485-762f-8986-3d019d072a87",
        "storage_key": "property/6767906449167175/019d021d-2485-762f-8986-3d019d072a87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV4eWU2hFMlERCV46xSbjRvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7844b013-3798-4386-ab91-f999c6ceacb8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Bentley Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "32 College Rd, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-7cff-752e-b430-3614efe53d45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-7cff-752e-b430-3614efe53d45",
        "storage_key": "property/6767906449167175/01a14113-7cff-752e-b430-3614efe53d45.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bentleymallfairbanks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1373676882826266169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bentley-mall",
      "poi_latitude": "64.8515421",
      "poi_longitude": "-147.7026852",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-456-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-24b2-75c1-abf3-b40b8f60c3f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-24b2-75c1-abf3-b40b8f60c3f3",
        "storage_key": "property/6767906449167175/019d021d-24b2-75c1-abf3-b40b8f60c3f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPUlcpkNFMlEROYYGzdhHEBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_ce06a1de-eb24-4d5f-a4ad-65893a6e7ecc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Three Bears Alaska",
      "poi_type": "Shopping & Retail",
      "poi_address": "1321 Wembley Ave, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-7b93-73ec-bfbc-53aa22d0ecda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-7b93-73ec-bfbc-53aa22d0ecda",
        "storage_key": "property/6767906449167175/01a14113-7b93-73ec-bfbc-53aa22d0ecda.webp",
        "width": 1280,
        "height": 670
      },
      "poi_business_url": "https://threebearsalaska.com/danby-convenience-gas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6230862448117387391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "three-bears-alaska",
      "poi_latitude": "64.8526253",
      "poi_longitude": "-147.7501537",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-455-1290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-ad4f-7471-88e7-6169728e6bbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14113-ad4f-7471-88e7-6169728e6bbc",
        "storage_key": "property/6767906449167175/01a14113-ad4f-7471-88e7-6169728e6bbc.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJK1X36sBFMlERf5BbUGJ4eFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_1e7ac7d8-073f-4794-a264-f8877d863358",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Arctic Light Elementary School",
      "poi_type": "Education",
      "poi_address": "4167 Neely Rd, Fort Wainwright, AK 99703, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-7be1-760c-be4f-83c7db7f4e00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-7be1-760c-be4f-83c7db7f4e00",
        "storage_key": "property/6767906449167175/01a14113-7be1-760c-be4f-83c7db7f4e00.webp",
        "width": 720,
        "height": 540
      },
      "poi_business_url": "http://www.k12northstar.org/site/Default.aspx?PageID=1746",
      "poi_directions_map_url": "https://maps.google.com/?cid=2385629355671437174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arctic-light-elementary-school",
      "poi_latitude": "64.82703599999999",
      "poi_longitude": "-147.6903499",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-356-2038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-24e7-76a8-8a37-3965515c8686",
        "storage_key": "property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgSZSDv9PMlERdj-KZkJ1GyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_0cfec250-3bbd-4519-ac41-6bc737247911",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Ladd Elementary School",
      "poi_type": "Education",
      "poi_address": "601 F St, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://lad.k12northstar.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13331996630311415396&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ladd-elementary-school",
      "poi_latitude": "64.8480486",
      "poi_longitude": "-147.6668363",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 907-451-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-24e7-76a8-8a37-3965515c8686",
        "storage_key": "property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZyA8-GBFMlERZK5qoEzEBLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ee770d8c-21e5-49bf-ab5f-b2e1db6c4d28",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Barnette Magnet School",
      "poi_type": "Education",
      "poi_address": "725 10th Ave, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-7dbb-729f-a656-1cc880b12f4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-7dbb-729f-a656-1cc880b12f4a",
        "storage_key": "property/6767906449167175/01a14113-7dbb-729f-a656-1cc880b12f4a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.k12northstar.org/barnette",
      "poi_directions_map_url": "https://maps.google.com/?cid=12307663690329705464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barnette-magnet-school",
      "poi_latitude": "64.8380075",
      "poi_longitude": "-147.7307694",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-456-6072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-24e7-76a8-8a37-3965515c8686",
        "storage_key": "property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ800NxUtFMlER-EsT5eqazao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_780e3270-ff79-4a26-9e23-894045fd161c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Ryan Middle School",
      "poi_type": "Education",
      "poi_address": "1450 Cowles St, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ryn.k12northstar.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=905761648768767553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ryan-middle-school",
      "poi_latitude": "64.83443609999999",
      "poi_longitude": "-147.7358107",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-452-4751",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-24e7-76a8-8a37-3965515c8686",
        "storage_key": "property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAfCyM7VaMlERQdYIrmvpkQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7882c47f-c817-4b68-b3cd-65c814806c87",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Lathrop High School",
      "poi_type": "Education",
      "poi_address": "901 Airport Way, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-cef3-741c-a605-1f9b0dbda48e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-cef3-741c-a605-1f9b0dbda48e",
        "storage_key": "property/6767906449167175/019d021c-cef3-741c-a605-1f9b0dbda48e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.k12northstar.org/lathrop",
      "poi_directions_map_url": "https://maps.google.com/?cid=14449100068518924675&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lathrop-high-school",
      "poi_latitude": "64.83609229999999",
      "poi_longitude": "-147.732013",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-456-7794",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-24e7-76a8-8a37-3965515c8686",
        "storage_key": "property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJceVJK7VaMlERg5EkLPWDhcg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_db627a4f-9df8-4e67-8a51-89ef5111d64f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Monroe Catholic High School",
      "poi_type": "Education",
      "poi_address": "615 Monroe St, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-7f07-721b-a42a-18ad45e83090.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-7f07-721b-a42a-18ad45e83090",
        "storage_key": "property/6767906449167175/01a14113-7f07-721b-a42a-18ad45e83090.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.catholic-schools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3505377703612527715&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monroe-catholic-high-school",
      "poi_latitude": "64.8513866",
      "poi_longitude": "-147.71628429999998",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-452-2044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-24e7-76a8-8a37-3965515c8686",
        "storage_key": "property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy7JMVkdFMlERYzRm-3KapTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_b33dd7b4-88e7-4eb9-8d36-1721a1cd486a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "University of Alaska Fairbanks",
      "poi_type": "Education",
      "poi_address": "505 S Chandalar, Fairbanks, AK 99775, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14111-0f82-7047-9210-84a856e7b486.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14111-0f82-7047-9210-84a856e7b486",
        "storage_key": "property/6767906449167175/01a14111-0f82-7047-9210-84a856e7b486.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.uaf.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3191271652891104789&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-alaska-fairbanks",
      "poi_latitude": "64.8555749",
      "poi_longitude": "-147.83405969999998",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-474-7034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-24e7-76a8-8a37-3965515c8686",
        "storage_key": "property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe1F2jzVbMlERFRZZBKmsSSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_af0239ff-85fa-4058-9af9-779746d669a2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Fairbanks Montessori School",
      "poi_type": "Education",
      "poi_address": "2014 30th Ave, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.fairbanksmontessori.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13854085641085214022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairbanks-montessori-school",
      "poi_latitude": "64.8206871",
      "poi_longitude": "-147.76069239999998",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-451-8485",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-24e7-76a8-8a37-3965515c8686",
        "storage_key": "property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ72KoI79aMlERRl25DH2ZQ8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_fe6b8110-80ce-4476-ba25-f62e3f82fe62",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Imagine That Childcare",
      "poi_type": "Education",
      "poi_address": "1007 Evergreen St, Fairbanks, AK 99709, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-813d-710c-9363-51694f920565.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-813d-710c-9363-51694f920565",
        "storage_key": "property/6767906449167175/01a14113-813d-710c-9363-51694f920565.webp",
        "width": 800,
        "height": 586
      },
      "poi_business_url": "http://www.imaginethatchildcare.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6658828022090965068&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "imagine-that-childcare",
      "poi_latitude": "64.85467249999999",
      "poi_longitude": "-147.7541393",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-456-5478",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-24e7-76a8-8a37-3965515c8686",
        "storage_key": "property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPeVU7iVFMlERTCAmXc7oaFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_24795726-1adc-431b-bed1-2b9d0dda93e0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Smart Start Learning Center",
      "poi_type": "Education",
      "poi_address": "3101 Lathrop St, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-80f5-73bd-bf26-e401714cc84d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-80f5-73bd-bf26-e401714cc84d",
        "storage_key": "property/6767906449167175/01a14113-80f5-73bd-bf26-e401714cc84d.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://smartstartfairbanks.com/contact/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9145131778459265535&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smart-start-learning-center",
      "poi_latitude": "64.8194771",
      "poi_longitude": "-147.74282399999998",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-459-4737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-24e7-76a8-8a37-3965515c8686",
        "storage_key": "property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVVXlD7taMlER_2kzR-YI6n4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_bfee7632-1219-4743-9ab8-f2d50f221eeb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Alaskaland",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2300 Airport Way, Fairbanks, AK 99701, USA",
      "poi_short_description": "Historical theme park showcasing everything from home life to aviation, plus mini-golf & a carousel.",
      "poi_long_description": "Historical theme park showcasing everything from home life to aviation, plus mini-golf & a carousel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14111-2d24-7327-ba29-2e1a77268866.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14111-2d24-7327-ba29-2e1a77268866",
        "storage_key": "property/6767906449167175/01a14111-2d24-7327-ba29-2e1a77268866.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fnsb.gov/462/Alaskaland",
      "poi_directions_map_url": "https://maps.google.com/?cid=6359608426705424476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaskaland",
      "poi_latitude": "64.83783509999999",
      "poi_longitude": "-147.7726478",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-459-1087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2a6f-707b-9462-9d0e74045b14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2a6f-707b-9462-9d0e74045b14",
        "storage_key": "property/6767906449167175/019d021d-2a6f-707b-9462-9d0e74045b14.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJowi3LdJaMlERXJBbYCveQVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_dd059b4f-e8a6-468e-a205-383579a4f601",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "University of Alaska Museum of the North",
      "poi_type": "Entertainment",
      "poi_address": "1962 Yukon Dr, Fairbanks, AK 99775, USA",
      "poi_short_description": "Exhibits showcasing Alaska's art, science & history housed in a swooping contemporary building.",
      "poi_long_description": "Exhibits showcasing Alaska's art, science & history housed in a swooping contemporary building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-d470-7480-8990-b4de86e8ec2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-d470-7480-8990-b4de86e8ec2f",
        "storage_key": "property/6767906449167175/019d021c-d470-7480-8990-b4de86e8ec2f.webp",
        "width": 851,
        "height": 350
      },
      "poi_business_url": "http://www.uaf.edu/museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11941309256582721113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-alaska-museum-of-the-north",
      "poi_latitude": "64.85848469999999",
      "poi_longitude": "-147.8423214",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 907-474-7505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2a49-706d-89be-cbd5ae5a329f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2a49-706d-89be-cbd5ae5a329f",
        "storage_key": "property/6767906449167175/019d021d-2a49-706d-89be-cbd5ae5a329f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJAca7fEtbMlERWW6yR4ANuKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_41cb33ca-7e37-4878-8a07-22745b787a76",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Fountainhead Antique Auto Museum",
      "poi_type": "Entertainment",
      "poi_address": "3225 Airport Way, Fairbanks, AK 99701, USA",
      "poi_short_description": "This resort museum offers guided tours, 70 historic automobiles & post-Gold Rush heritage exhibits.",
      "poi_long_description": "This resort museum offers guided tours, 70 historic automobiles & post-Gold Rush heritage exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-6999-77af-8615-7fa696203c94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021d-6999-77af-8615-7fa696203c94",
        "storage_key": "property/6767906449167175/019d021d-6999-77af-8615-7fa696203c94.webp",
        "width": 1280,
        "height": 874
      },
      "poi_business_url": "http://www.fountainheadmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15448597233625019430&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fountainhead-antique-auto-museum",
      "poi_latitude": "64.83628209999999",
      "poi_longitude": "-147.7991566",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-450-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2a49-706d-89be-cbd5ae5a329f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2a49-706d-89be-cbd5ae5a329f",
        "storage_key": "property/6767906449167175/019d021d-2a49-706d-89be-cbd5ae5a329f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJmb76ZhZFMlERJjRNdFVxZNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d8540227-0275-4a98-9244-dd9fa6686a14",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Fairbanks Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "302 Cushman St Ste 101, Fairbanks, AK 99701, USA",
      "poi_short_description": "Family attraction offering children the chance to explore the world through interactive play.",
      "poi_long_description": "Family attraction offering children the chance to explore the world through interactive play.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14111-15b6-773d-8446-a95058f20b33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14111-15b6-773d-8446-a95058f20b33",
        "storage_key": "property/6767906449167175/01a14111-15b6-773d-8446-a95058f20b33.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.fairbankschildrensmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17525343963565208319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairbanks-childrens-museum",
      "poi_latitude": "64.8425",
      "poi_longitude": "-147.7216667",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-374-7060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2a49-706d-89be-cbd5ae5a329f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2a49-706d-89be-cbd5ae5a329f",
        "storage_key": "property/6767906449167175/019d021d-2a49-706d-89be-cbd5ae5a329f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6X1a-UhFMlER_zLXSnuHNvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_43439c1d-f729-4e49-8931-c4d66952962f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Regal Goldstream",
      "poi_type": "Entertainment",
      "poi_address": "1855 Airport Way, Fairbanks, AK 99701, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-847d-741e-ba19-32f964614a0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-847d-741e-ba19-32f964614a0d",
        "storage_key": "property/6767906449167175/01a14113-847d-741e-ba19-32f964614a0d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-goldstream-0601?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12188091834901064291&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-goldstream",
      "poi_latitude": "64.83525759999999",
      "poi_longitude": "-147.7529336",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-258e-737d-9d7a-760a46577ffa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-258e-737d-9d7a-760a46577ffa",
        "storage_key": "property/6767906449167175/019d021d-258e-737d-9d7a-760a46577ffa.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJl9BAjstaMlERY-od1fLMJKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_b73edcde-39b3-46c2-b8cd-a15f2c889c6d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Carlson Center",
      "poi_type": "Entertainment",
      "poi_address": "2010 2nd Ave, Fairbanks, AK 99701, USA",
      "poi_short_description": "Versatile event venue hosting sports, hockey, and varied community expos.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-85ab-7109-a5dd-7ef86fe582a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-85ab-7109-a5dd-7ef86fe582a5",
        "storage_key": "property/6767906449167175/01a14113-85ab-7109-a5dd-7ef86fe582a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fnsb.gov/985/Carlson-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=2352742900236255017&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carlson-center",
      "poi_latitude": "64.8418006",
      "poi_longitude": "-147.7642268",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-459-1227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-ad5c-7158-ad05-3f4033d09083.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14113-ad5c-7158-ad05-3f4033d09083",
        "storage_key": "property/6767906449167175/01a14113-ad5c-7158-ad05-3f4033d09083.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJL33XsdJaMlERKX9n0DOfpiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_b7134ce2-0082-4fdc-9b45-a5f451df16b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Morris Thompson Cultural & Visitors Center",
      "poi_type": "Entertainment",
      "poi_address": "101 Dunkel St, Fairbanks, AK 99701, USA",
      "poi_short_description": "Free-admission center offering travel advice & information plus exhibits on Native Alaskan culture.",
      "poi_long_description": "Free-admission center offering travel advice & information plus exhibits on Native Alaskan culture.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-d73f-758e-81bd-63846fa94a6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-d73f-758e-81bd-63846fa94a6f",
        "storage_key": "property/6767906449167175/019d021c-d73f-758e-81bd-63846fa94a6f.webp",
        "width": 1280,
        "height": 673
      },
      "poi_business_url": "http://www.morristhompsoncenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4969884833292439743&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morris-thompson-cultural--visitors-center",
      "poi_latitude": "64.8460029",
      "poi_longitude": "-147.7127243",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-459-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-ad5c-7158-ad05-396d286290e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14113-ad5c-7158-ad05-396d286290e5",
        "storage_key": "property/6767906449167175/01a14113-ad5c-7158-ad05-396d286290e5.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJ1feeREZFMlERv1D_nuyT-EQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_14110aac-1471-4095-a643-84414c9b3cba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Lavelle's Taphouse",
      "poi_type": "Restaurants",
      "poi_address": "412 2nd Ave, Fairbanks, AK 99701, USA",
      "poi_short_description": "Relaxed taphouse featuring a rotating selection of craft beers and ciders.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-8a9f-775d-abd6-618b30e12a6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-8a9f-775d-abd6-618b30e12a6e",
        "storage_key": "property/6767906449167175/01a14113-8a9f-775d-abd6-618b30e12a6e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://lavellestaphouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9981537075107071606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lavelles-taphouse",
      "poi_latitude": "64.843784",
      "poi_longitude": "-147.716613",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-888-2220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20bb-768f-aa9e-7f53e1779418.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20bb-768f-aa9e-7f53e1779418",
        "storage_key": "property/6767906449167175/019d021d-20bb-768f-aa9e-7f53e1779418.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_eLHmUhFMlERdgYm2hWLhYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_30f92136-275f-4d64-bfe5-79b1abb106c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Pike's Waterfront Lodge",
      "poi_type": "Entertainment",
      "poi_address": "1850 Hoselton Rd, Fairbanks, AK 99709, USA",
      "poi_short_description": "Old-school rooms & rustic cabins in a laid-back hotel offering a restaurant & a bar, plus mini-golf.",
      "poi_long_description": "Old-school rooms & rustic cabins in a laid-back hotel offering a restaurant & a bar, plus mini-golf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-8ac2-712a-bd7e-35cdf4b36836.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-8ac2-712a-bd7e-35cdf4b36836",
        "storage_key": "property/6767906449167175/01a14113-8ac2-712a-bd7e-35cdf4b36836.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pikeslodge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17176422175994459117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pikes-waterfront-lodge",
      "poi_latitude": "64.8311337",
      "poi_longitude": "-147.8478188",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 877-774-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2a4f-7560-8635-f49974715b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2a4f-7560-8635-f49974715b02",
        "storage_key": "property/6767906449167175/019d021d-2a4f-7560-8635-f49974715b02.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJAXRAGhdbMlER7bNK6PboXu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_48ebc391-567d-449b-8db1-754844bd4c5f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Fairbanks Memorial Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1650 Cowles St, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-e49a-75ef-90af-33405bd083c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-e49a-75ef-90af-33405bd083c6",
        "storage_key": "property/6767906449167175/019d021c-e49a-75ef-90af-33405bd083c6.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://www.foundationhealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11373563386302644046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairbanks-memorial-hospital",
      "poi_latitude": "64.83127879999999",
      "poi_longitude": "-147.7386277",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-452-8181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2bcf-762f-94d6-40749fda5276.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2bcf-762f-94d6-40749fda5276",
        "storage_key": "property/6767906449167175/019d021d-2bcf-762f-94d6-40749fda5276.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJu-6hMbRaMlERTj_13qMD150",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_384667ca-aa76-4d60-bc09-82c6cb00acfa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Bassett Army Community Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4076 Neely Rd, Fort Wainwright, AK 99703, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-0827-750a-aeb0-66007850ca5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021d-0827-750a-aeb0-66007850ca5c",
        "storage_key": "property/6767906449167175/019d021d-0827-750a-aeb0-66007850ca5c.webp",
        "width": 1280,
        "height": 696
      },
      "poi_business_url": "https://bassett-wainwright.tricare.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4051943907050653539&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bassett-army-community-hospital",
      "poi_latitude": "64.83006499999999",
      "poi_longitude": "-147.6636608",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-361-5172",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2bcf-762f-94d6-40749fda5276.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2bcf-762f-94d6-40749fda5276",
        "storage_key": "property/6767906449167175/019d021d-2bcf-762f-94d6-40749fda5276.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ970uX5ZPMlERYweQ7YNlOzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6cd454e0-250d-4408-b928-810bc07369c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1867 Airport Way Suite 110C, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-88b2-713a-a244-27d2f1d4b678.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-88b2-713a-a244-27d2f1d4b678",
        "storage_key": "property/6767906449167175/01a14113-88b2-713a-a244-27d2f1d4b678.webp",
        "width": 739,
        "height": 415
      },
      "poi_business_url": "http://www.concentra.com/?utm_source=Yext&utm_medium=Organic&utm_campaign=Homepage%20Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=9603188347256415641&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "64.8357733",
      "poi_longitude": "-147.7565512",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-452-2178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20b8-7511-9710-25d994c883f8",
        "storage_key": "property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3UMU9ctaMlERmaVjBexgRYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_3bbcedae-cb09-465f-91d7-81a35854c328",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Safeway Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "30 College Rd, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-8995-70b2-88f3-1a2e8a2c7292.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-8995-70b2-88f3-1a2e8a2c7292",
        "storage_key": "property/6767906449167175/01a14113-8995-70b2-88f3-1a2e8a2c7292.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://local.pharmacy.safeway.com/safeway/ak/fairbanks/30-college-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6389941304382334339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway-pharmacy",
      "poi_latitude": "64.8516183",
      "poi_longitude": "-147.7008176",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 907-374-4160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2df8-7698-807e-c26f0df7f0d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2df8-7698-807e-c26f0df7f0d0",
        "storage_key": "property/6767906449167175/019d021d-2df8-7698-807e-c26f0df7f0d0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ92tUfEFFMlERgyVOz8KhrVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_7c26feca-7279-4a88-a112-f95f49dcfc46",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Fred Meyer Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1384 University Ave, Fairbanks, AK 99709, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-8bdf-75ea-91f2-62377c178a3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-8bdf-75ea-91f2-62377c178a3e",
        "storage_key": "property/6767906449167175/01a14113-8bdf-75ea-91f2-62377c178a3e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fredmeyer.com/rx/pharmacy/details/701/00485?cid=loc_70100485P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2727436645669684469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer-pharmacy",
      "poi_latitude": "64.8354442",
      "poi_longitude": "-147.8175924",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-474-1433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2df8-7698-807e-c26f0df7f0d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2df8-7698-807e-c26f0df7f0d0",
        "storage_key": "property/6767906449167175/019d021d-2df8-7698-807e-c26f0df7f0d0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc-j_HSRbMlER9USGvC3N2SU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_d2f70655-e9b9-4887-87b5-20033e9290d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1255 Airport Way, Fairbanks, AK 99701, USA",
      "poi_short_description": "Budget-friendly gym offering diverse fitness equipment and tanning services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-6f89-7178-850c-61a7444480d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021d-6f89-7178-850c-61a7444480d2",
        "storage_key": "property/6767906449167175/019d021d-6f89-7178-850c-61a7444480d2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/fairbanks-ak?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11587579933743172574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "64.8355809",
      "poi_longitude": "-147.7426333",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-374-4441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20b8-7511-9710-25d994c883f8",
        "storage_key": "property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfphpspaMlER3ss0XY5az6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bdc6834e-c791-43b5-b1c4-1f0593a464aa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "The Alaska Club Fairbanks West Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "575 Riverstone Wy, Fairbanks, AK 99709, USA",
      "poi_short_description": "Members-only chain health club offering 24/7 access to exercise equipment, a pool, and tanning.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-8f09-706b-abd6-755646feaaca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-8f09-706b-abd6-755646feaaca",
        "storage_key": "property/6767906449167175/01a14113-8f09-706b-abd6-755646feaaca.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thealaskaclub.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-tacfbxwest-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=876910736493129038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-alaska-club-fairbanks-west-gym",
      "poi_latitude": "64.8469665",
      "poi_longitude": "-147.8646889",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 907-452-3777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20b8-7511-9710-25d994c883f8",
        "storage_key": "property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK3KY-kNbMlERTi1mNKtpKww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d83d555d-4d02-4b7e-9d4e-1e07cc5b1fb2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "SunDog CrossFit",
      "poi_type": "Health and Wellness",
      "poi_address": "3501 Lathrop St D, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-9157-73ac-8dc9-b51246b00b5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-9157-73ac-8dc9-b51246b00b5c",
        "storage_key": "property/6767906449167175/01a14113-9157-73ac-8dc9-b51246b00b5c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sundogcrossfit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9228894840187231014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sundog-crossfit",
      "poi_latitude": "64.8133204",
      "poi_longitude": "-147.7436043",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-415-1683",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-24e7-76a8-8a37-3965515c8686",
        "storage_key": "property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCTiH2SZbMlERJpvL2vWeE4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_91e7ea4e-91da-407a-b840-74abd311ae36",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Trax Outdoor Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "310 Birch Hill Rd, Fairbanks, AK 99712, USA",
      "poi_short_description": "Friendly, accommodating business offering skiing gear, rentals and classes as well as yoga sessions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-92ed-773d-8c28-dd40ab317bbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-92ed-773d-8c28-dd40ab317bbd",
        "storage_key": "property/6767906449167175/01a14113-92ed-773d-8c28-dd40ab317bbd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://traxoutdoorcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17591218088408887021&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trax-outdoor-center",
      "poi_latitude": "64.869396",
      "poi_longitude": "-147.66916849999998",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 907-374-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-24b2-75c1-abf3-b40b8f60c3f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-24b2-75c1-abf3-b40b8f60c3f3",
        "storage_key": "property/6767906449167175/019d021d-24b2-75c1-abf3-b40b8f60c3f3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxfEOhHZFMlER7a4JLqaPIPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_0e0ba220-f487-4d2e-8598-4ae0af9a309d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Friends of Creamers Field at Creamer's Field Migratory Waterfowl Refuge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1300 College Rd, Fairbanks, AK 99701, USA",
      "poi_short_description": "Wildlife sanctuary & landmark dairy farm offering bird observation & nature education.",
      "poi_long_description": "Wildlife sanctuary & landmark dairy farm offering bird observation & nature education.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14111-3003-716e-84fe-a4a5e5725cb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14111-3003-716e-84fe-a4a5e5725cb3",
        "storage_key": "property/6767906449167175/01a14111-3003-716e-84fe-a4a5e5725cb3.webp",
        "width": 1280,
        "height": 875
      },
      "poi_business_url": "https://friendsofcreamersfield.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4766821813016861985&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "friends-of-creamers-field-at-creamers-field-migratory-waterfowl-refuge",
      "poi_latitude": "64.8633179",
      "poi_longitude": "-147.738081",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-978-8457",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2a6f-707b-9462-9d0e74045b14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2a6f-707b-9462-9d0e74045b14",
        "storage_key": "property/6767906449167175/019d021d-2a6f-707b-9462-9d0e74045b14.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJuWFy0A9FMlERIR106C4nJ0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_refuge"
    },
    {
      "id": "custom_60639dba-a588-4053-b599-0588c1311dcf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Wedgewood Wildlife Sanctuary",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "212 Wedgewood Dr, Fairbanks, AK 99701, USA",
      "poi_short_description": "Small, scenic natural area with a lakeside walking trail, wildlife viewing & interpretive signs.",
      "poi_long_description": "Small, scenic natural area with a lakeside walking trail, wildlife viewing & interpretive signs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14111-2fa5-70eb-8a91-82725d732161.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14111-2fa5-70eb-8a91-82725d732161",
        "storage_key": "property/6767906449167175/01a14111-2fa5-70eb-8a91-82725d732161.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.alaska.org/detail/fountainhead-wedgewood-wildlife-sanctuary",
      "poi_directions_map_url": "https://maps.google.com/?cid=3979918612030439657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wedgewood-wildlife-sanctuary",
      "poi_latitude": "64.8615864",
      "poi_longitude": "-147.71367429999998",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-452-1442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2a6f-707b-9462-9d0e74045b14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2a6f-707b-9462-9d0e74045b14",
        "storage_key": "property/6767906449167175/019d021d-2a6f-707b-9462-9d0e74045b14.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJhxT7ZhZFMlER6UAKIeSCOzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_60a5429c-51b2-4e1e-8a15-85d91df81999",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Georgeson Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2180 W Tanana Dr, Fairbanks, AK 99709, USA",
      "poi_short_description": "Calm spot highlighting native & introduced plants, plus picnic areas & a kids' garden with a maze.",
      "poi_long_description": "Calm spot highlighting native & introduced plants, plus picnic areas & a kids' garden with a maze.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-f3be-727f-869e-6e763152a67f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021c-f3be-727f-869e-6e763152a67f",
        "storage_key": "property/6767906449167175/019d021c-f3be-727f-869e-6e763152a67f.webp",
        "width": 600,
        "height": 399
      },
      "poi_business_url": "http://www.georgesonbotanicalgarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3525159237246278657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgeson-botanical-garden",
      "poi_latitude": "64.8560723",
      "poi_longitude": "-147.8600722",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 907-474-6921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14111-433c-750c-a38d-5f210188c0d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14111-433c-750c-a38d-5f210188c0d4",
        "storage_key": "property/6767906449167175/01a14111-433c-750c-a38d-5f210188c0d4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ-_h1VFbMlERAVzAMKbh6zA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_3e9f9f6d-792f-4294-89ff-0106c4b420e2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Birch Hill Recreation Area",
      "poi_type": "Health and Wellness",
      "poi_address": "101 Wilderness Dr, Fairbanks, AK 99712, USA",
      "poi_short_description": "Year-round recreation center offering extensive cross-country ski and hiking trails and a versatile event space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-9553-7670-8abe-c61683d4c188.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-9553-7670-8abe-c61683d4c188",
        "storage_key": "property/6767906449167175/01a14113-9553-7670-8abe-c61683d4c188.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.nscfairbanks.org/trails/birch-hill-facilities/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9942939757633119559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "birch-hill-recreation-area",
      "poi_latitude": "64.8700878",
      "poi_longitude": "-147.64737689999998",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 907-457-4488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2a6f-707b-9462-9d0e74045b14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2a6f-707b-9462-9d0e74045b14",
        "storage_key": "property/6767906449167175/019d021d-2a6f-707b-9462-9d0e74045b14.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJR_CUn4JFMlERR6XUlAdr_Ik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_70889a0b-e6fa-4c4b-8d33-052efcd1efe0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Chena Riverwalk",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Moore St, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-96d3-769d-b009-2b8a31c5917c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-96d3-769d-b009-2b8a31c5917c",
        "storage_key": "property/6767906449167175/01a14113-96d3-769d-b009-2b8a31c5917c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.alaska.org/detail/chena-riverwalk",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534264529095766885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chena-riverwalk",
      "poi_latitude": "64.8396648",
      "poi_longitude": "-147.7683248",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-ad69-7467-a9ca-f869e36e816a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14113-ad69-7467-a9ca-f869e36e816a",
        "storage_key": "property/6767906449167175/01a14113-ad69-7467-a9ca-f869e36e816a.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ84hBAtBbMlERZTOICS6n8q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_7796d134-8f25-4f64-ace5-10636fd011dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Growden Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "207 Wilbur St, Fairbanks, AK 99701, USA",
      "poi_short_description": "Community park featuring baseball fields and recreational amenities including a playground and skate park.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-94cc-72ab-8e12-2c468f7a1cad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-94cc-72ab-8e12-2c468f7a1cad",
        "storage_key": "property/6767906449167175/01a14113-94cc-72ab-8e12-2c468f7a1cad.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.alaska.org/detail/growden-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=467689544042906344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "growden-park",
      "poi_latitude": "64.8396245",
      "poi_longitude": "-147.7594083",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-459-1070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2a6f-707b-9462-9d0e74045b14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2a6f-707b-9462-9d0e74045b14",
        "storage_key": "property/6767906449167175/019d021d-2a6f-707b-9462-9d0e74045b14.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTTt828xaMlER6ILXkSmRfQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_67d12a8a-8ae4-482e-bdab-638c7fd9d6a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Fairbanks Dog Park 2nd Ave",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1890 2nd Ave, Fairbanks, AK 99701, USA",
      "poi_short_description": "Well-maintained dog park featuring fenced spaces for exercise and canine socialization.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-998d-7252-b92a-5f4b05c16a5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-998d-7252-b92a-5f4b05c16a5e",
        "storage_key": "property/6767906449167175/01a14113-998d-7252-b92a-5f4b05c16a5e.webp",
        "width": 850,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17261500009027883268&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairbanks-dog-park-2nd-ave",
      "poi_latitude": "64.8423318",
      "poi_longitude": "-147.75512999999998",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2a6f-707b-9462-9d0e74045b14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2a6f-707b-9462-9d0e74045b14",
        "storage_key": "property/6767906449167175/019d021d-2a6f-707b-9462-9d0e74045b14.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZUXKUdFMlERBFGCiM0qje8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_57ff9195-07ed-4bd9-bf7c-405ba3cde6f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Tanana Lakes Recreation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4400 S Cushman St Exd, Fairbanks, AK 99701, USA",
      "poi_short_description": "Versatile recreation area featuring swimming beaches and diverse hiking trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-9bd2-72c1-a0d3-3c1d1d4c97f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-9bd2-72c1-a0d3-3c1d1d4c97f3",
        "storage_key": "property/6767906449167175/01a14113-9bd2-72c1-a0d3-3c1d1d4c97f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fairbanksak.myrec.com/info/facilities/details.aspx?FacilityID=14702",
      "poi_directions_map_url": "https://maps.google.com/?cid=12538769058836681270&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tanana-lakes-recreation-area",
      "poi_latitude": "64.80005849999999",
      "poi_longitude": "-147.729303",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 907-459-1070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20b8-7511-9710-25d994c883f8",
        "storage_key": "property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv2bRJHZQMlERNpKemAaoAq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "picnic_ground"
    },
    {
      "id": "custom_24648881-32cf-462d-b6b1-f3862ed49fe3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Bud Nelson Riverside Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "71 Slater Dr, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17784756994384919462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bud-nelson-riverside-park",
      "poi_latitude": "64.8439216",
      "poi_longitude": "-147.703311",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2a6f-707b-9462-9d0e74045b14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2a6f-707b-9462-9d0e74045b14",
        "storage_key": "property/6767906449167175/019d021d-2a6f-707b-9462-9d0e74045b14.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJg4Wkd49FMlERpvv0OkIm0PY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_516e8dbe-9242-48ac-99c5-57998a6da0b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Macs Bus Schedule Info",
      "poi_type": "Major Employers & Offices",
      "poi_address": "501 Cushman St, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-9c03-7625-b98c-ffc12a9dccda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-9c03-7625-b98c-ffc12a9dccda",
        "storage_key": "property/6767906449167175/01a14113-9c03-7625-b98c-ffc12a9dccda.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.fnsb.gov/353/Bus-Routes---Maps-Schedules",
      "poi_directions_map_url": "https://maps.google.com/?cid=11532040112589069106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macs-bus-schedule-info",
      "poi_latitude": "64.84162979999999",
      "poi_longitude": "-147.71981650000004",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-459-1011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2e26-73bc-86f9-fa9c6fd788dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2e26-73bc-86f9-fa9c6fd788dd",
        "storage_key": "property/6767906449167175/019d021d-2e26-73bc-86f9-fa9c6fd788dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuWfWI0lFMlERMlttDmIJCqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_b4087971-8d86-4556-bb36-40d335f0e093",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Fairbanks International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6450 Airport Way, Fairbanks, AK 99709, USA",
      "poi_short_description": "Servicing Central Alaska, this airport features a military lounge plus a shop offering local gifts.",
      "poi_long_description": "Servicing Central Alaska, this airport features a military lounge plus a shop offering local gifts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14111-3651-731c-821b-582b1c451a4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14111-3651-731c-821b-582b1c451a4d",
        "storage_key": "property/6767906449167175/01a14111-3651-731c-821b-582b1c451a4d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://dot.alaska.gov/faiiap/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16696475753248562178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairbanks-international-airport",
      "poi_latitude": "64.8155444",
      "poi_longitude": "-147.8594616",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 907-474-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2e65-74db-9043-5986829f740b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2e65-74db-9043-5986829f740b",
        "storage_key": "property/6767906449167175/019d021d-2e65-74db-9043-5986829f740b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJzTJ6LQ9bMlERApxNYTzMtec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_26596eb6-1e63-4563-9cab-02ccd7d78132",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Alaska Railroad - Fairbanks Depot",
      "poi_type": "Transportation & Transit",
      "poi_address": "1031 Alaska Railroad Depot Rd, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-9e2d-76b3-ac6c-a7fd393890aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-9e2d-76b3-ac6c-a7fd393890aa",
        "storage_key": "property/6767906449167175/01a14113-9e2d-76b3-ac6c-a7fd393890aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alaskarailroad.com/ride-a-train/depot-locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=5123528392382919124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alaska-railroad---fairbanks-depot",
      "poi_latitude": "64.85135079999999",
      "poi_longitude": "-147.7408173",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-458-6025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20b8-7511-9710-25d994c883f8",
        "storage_key": "property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-xTRjzpFMlER1LGcYO1tGkc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_930fb6d6-0d7f-46bc-8e75-127485e0e003",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "William Ransom Wood Campus Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "1731 S Chandalar, Fairbanks, AK 99709, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-a3a4-764c-a264-5832087988b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-a3a4-764c-a264-5832087988b9",
        "storage_key": "property/6767906449167175/01a14113-a3a4-764c-a264-5832087988b9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.uaf.edu/woodcenter",
      "poi_directions_map_url": "https://maps.google.com/?cid=7040611398260151486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-ransom-wood-campus-center",
      "poi_latitude": "64.8574275",
      "poi_longitude": "-147.823481",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 907-474-7034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20b8-7511-9710-25d994c883f8",
        "storage_key": "property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYUQN08pEMlERvtTcksNGtWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_42f683c7-84e4-4172-91ac-5957ce8c31e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "MAC Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "1770 Tesoro Ave, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5042869816629404699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mac-transit",
      "poi_latitude": "64.8185944",
      "poi_longitude": "-147.74687",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2e26-73bc-86f9-fa9c6fd788dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2e26-73bc-86f9-fa9c6fd788dd",
        "storage_key": "property/6767906449167175/019d021d-2e26-73bc-86f9-fa9c6fd788dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQxxQewBbMlERGyS8RGHf-0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_8b347dd0-b279-425c-ad4a-53d7cbb6127f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Holiday Inn Express Northern Lights Inn",
      "poi_type": "Health and Wellness",
      "poi_address": "Building, 3402 Santiago Ave, Fort Wainwright, AK 99703, USA",
      "poi_short_description": "Unassuming rooms & suites in a relaxed hotel featuring a breakfast buffet, a gym & BBQ facilities.",
      "poi_long_description": "Unassuming rooms & suites in a relaxed hotel featuring a breakfast buffet, a gym & BBQ facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-9fe2-7682-a0d3-172986767158.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-9fe2-7682-a0d3-172986767158",
        "storage_key": "property/6767906449167175/01a14113-9fe2-7682-a0d3-172986767158.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.ihg.com/armyhotels/hotels/us/en/fort-wainright/mfwak/hoteldetail?cm_mmc=GoogleMaps-_-MA-_-US-_-MFWAK",
      "poi_directions_map_url": "https://maps.google.com/?cid=6626071423234221383&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holiday-inn-express-northern-lights-inn",
      "poi_latitude": "64.8229498",
      "poi_longitude": "-147.6309728",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-370-0999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2a4f-7560-8635-f49974715b02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2a4f-7560-8635-f49974715b02",
        "storage_key": "property/6767906449167175/019d021d-2a4f-7560-8635-f49974715b02.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJH5dFo9xPMlERRyU-XtqI9Fs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_54cf9260-0a8d-4106-8bf7-8485009042bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Fairbanks North Star Borough Administration Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "907 Terminal St, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14111-3a78-7519-8ac6-f38b940f0f6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14111-3a78-7519-8ac6-f38b940f0f6b",
        "storage_key": "property/6767906449167175/01a14111-3a78-7519-8ac6-f38b940f0f6b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.fnsb.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15106473943648519361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairbanks-north-star-borough-administration-center",
      "poi_latitude": "64.8453",
      "poi_longitude": "-147.72551959999998",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-459-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20b8-7511-9710-25d994c883f8",
        "storage_key": "property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuaBp4DdFMlERwUTdowP6pNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_82739c98-8587-42bc-8e77-2c7f5600c897",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Fairbanks City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "800 Cushman St, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-861e-73de-8e80-3e085517c300.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021d-861e-73de-8e80-3e085517c300",
        "storage_key": "property/6767906449167175/019d021d-861e-73de-8e80-3e085517c300.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.fairbanksalaska.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15398628346624094053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairbanks-city-hall",
      "poi_latitude": "64.8397992",
      "poi_longitude": "-147.7209936",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-459-6715",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2e26-73bc-86f9-fa9c6fd788dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2e26-73bc-86f9-fa9c6fd788dd",
        "storage_key": "property/6767906449167175/019d021d-2e26-73bc-86f9-fa9c6fd788dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVTgDEhFMlERZS_KVOXqstU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_47482450-5115-45c9-9e7b-c3882d5c8d2f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Fairbanks North Star Borough School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "520 5th Ave, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-a348-74cd-9078-55d4a232671d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-a348-74cd-9078-55d4a232671d",
        "storage_key": "property/6767906449167175/01a14113-a348-74cd-9078-55d4a232671d.webp",
        "width": 577,
        "height": 1280
      },
      "poi_business_url": "https://education.alaska.gov/DOE_Rolodex/SchoolCalendar/Home/SchoolDetails/167010",
      "poi_directions_map_url": "https://maps.google.com/?cid=2243227692791310774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairbanks-north-star-borough-school-district",
      "poi_latitude": "64.84208459999999",
      "poi_longitude": "-147.7179514",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 907-452-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-24e7-76a8-8a37-3965515c8686",
        "storage_key": "property/6767906449167175/019d021d-24e7-76a8-8a37-3965515c8686.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ44412khFMlERtiklk7OLIR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f8a8cb29-7515-44d3-93e1-346edbc304b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Fairbanks Correctional Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1931 Eagan Ave, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5994684642124246078&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairbanks-correctional-center",
      "poi_latitude": "64.8333367",
      "poi_longitude": "-147.7591515",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 907-458-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2e26-73bc-86f9-fa9c6fd788dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2e26-73bc-86f9-fa9c6fd788dd",
        "storage_key": "property/6767906449167175/019d021d-2e26-73bc-86f9-fa9c6fd788dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ8Pt_8taMlERPixOuutlMVM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_5217ba30-4ace-4e01-b121-32d4fe6582ec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "State of Alaska Fairbanks Regional Office Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "State Of Alaska Fairbanks Regional Office Building, 675 7th Ave # D, Fairbanks, AK 99701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://dot.alaska.gov/dfs/leasing/othercities.shtml",
      "poi_directions_map_url": "https://maps.google.com/?cid=11313586396047765194&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "state-of-alaska-fairbanks-regional-office-building",
      "poi_latitude": "64.84053279999999",
      "poi_longitude": "-147.7248435",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 907-465-5689",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-2e26-73bc-86f9-fa9c6fd788dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-2e26-73bc-86f9-fa9c6fd788dd",
        "storage_key": "property/6767906449167175/019d021d-2e26-73bc-86f9-fa9c6fd788dd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6q6eklFMlERym4eoOLuAZ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_7733c7a3-0e3a-491a-8081-7c4824ee48d4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "custom",
      "poi_name": "Carlile Transportation",
      "poi_type": "Transportation & Transit",
      "poi_address": "900 Aurora Dr, Fairbanks, AK 99709, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a14113-a6b4-74fb-be16-40a3a04ef7a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14113-a6b4-74fb-be16-40a3a04ef7a4",
        "storage_key": "property/6767906449167175/01a14113-a6b4-74fb-be16-40a3a04ef7a4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.carlile.biz/contact-and-terminals/fairbanks/?=gmb_profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=12633367488542122207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carlile-transportation",
      "poi_latitude": "64.85242099999999",
      "poi_longitude": "-147.7627967",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 907-451-7155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021d-20b8-7511-9710-25d994c883f8",
        "storage_key": "property/6767906449167175/019d021d-20b8-7511-9710-25d994c883f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfRen1yhFMlER36CF38u8Uq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "moving_company"
    }
  ],
  "office_hours": [
    {
      "id": "ec_bb4490dfd7a458324df79409",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_b05ae4332c01717e2955a748",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_b2ddfc4ba736dd9b19cccfe8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_e8289aff85c781db13e1faa9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_e491cab18f8f8a58d13b103c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_05d81296-bcae-4470-847c-026955e6b3fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "rating": "5.0",
      "name": "Ignacio Re",
      "text": "We are three months into our rental at Birtchwood and so far l o v e it! The staff is great, friendly, knowledgeable, responsive and flexible.  Location is great as is only two miles and less than 6 minutes drive.  The grounds are well kept.  Lots of families with children turns this place festive for kiddos.  I recommend it for your family too.",
      "date": "2025-10-31",
      "title": ""
    },
    {
      "id": "custom_d3f9cb1d-a6f7-4877-a347-76497cffc830",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "rating": "5.0",
      "name": "Kioni Cruz",
      "text": "My family and I recently moved in and I will say that the level of customer service we received from start to finish from the staff in Fairbanks was phenomenal. Tayler was our agent/Rep and she went above and beyond to ensure that we got the place we needed and wanted. She gave us all the details and went over everything very well and answered all our questions. My family and I a grateful for Tayler and the staff being so welcoming and guiding us through the process with no issues. Thank you Tayler and all the staff!",
      "date": "2025-11-11",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_32f4928d8020aab2b4ee9618",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "false",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://www.youtube.com/embed/lKsBjjt8154"
    }
  ],
  "faqs": [],
  "pet_policies": [
    {
      "id": "ec_9894ea249413b1a759f191a9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "2466392",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 300,
      "monthly_rent": 40,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_c4298a8db0c0966addb9128c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "yardi",
      "external_id": "2466391",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 300,
      "monthly_rent": 40,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-d6b5-718e-8ec4-14cd7dc66584",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Birchwood Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "generator",
      "page_item_url": "birchwood-apartments-with-washer-dryer-hook-ups",
      "search_query": "apartments with washer and dryer hook ups fairbanks ak",
      "category": "Amenity",
      "h1_title": "Apartments With Washer/Dryer Hook Ups in Fairbanks AK",
      "h2_subtitle": "Looking for apartments with washer and dryer hook ups in Fairbanks AK? Birchwood offers customizable living spaces including this convenient amenity.",
      "page_copy": "Nestled in the heart of Fairbanks, Birchwood stands out with its baseball and tennis courts, and offers the modern convenience of washer and dryer hookups in select units. These features are designed to meet the diverse needs of our residents, providing greater flexibility and ease of living.\n\nAlongside its top-tier amenities, residents enjoy the on-site maintenance and management team, ensuring that any issues are swiftly resolved. Our smoke-free community prioritizes health and comfort, making Birchwood the ideal choice for those seeking functional and amenity-rich apartments. Discover a hassle-free lifestyle with exquisite amenities in Fairbanks, AK.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Washer/Dryer Hook Up Apts - Birchwood Fairbanks AK",
      "seo_description": "Discover Birchwood in Fairbanks AK, offering apartments with convenient washer and dryer hook ups. Enjoy top amenities like sports courts and on-site management.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "generator",
      "page_item_url": "birchwood-smoke-free-apartments-fairbanks-north-star",
      "search_query": "smoke free apartments in fairbanks north star borough",
      "category": "Amenity",
      "h1_title": "Smoke Free Apartments in Fairbanks North Star",
      "h2_subtitle": "Discover smoke free apartments in Fairbanks North Star Borough at Birchwood. Enjoy a breath of fresh air in a community committed to your health and comfort.",
      "page_copy": "Birchwood Apartments in the Fairbanks North Star Borough offer more than just a place to live—they provide a smoke free environment that prioritizes the well-being of its residents. Here, maintaining a fresh and healthy atmosphere is as important as offering spacious living options.\n\nOur community also features perks like basketball and tennis courts, alongside exceptional on-site maintenance services. Choose Birchwood if you're seeking a healthy lifestyle without sacrificing access to convenient amenities. Experience the benefits of a smoke-free home surrounded by welcoming neighbors and supportive staff right here in Fairbanks, AK.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke Free Apartments in Fairbanks North Star Borough",
      "seo_description": "Experience smoke free living at Birchwood Apartments in Fairbanks North Star Borough. Enjoy top amenities in a health-focused community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "generator",
      "page_item_url": "birchwood-cedar-deck-porches-apartments",
      "search_query": "fairbanks ak apartments with cedar deck porches",
      "category": "Amenity",
      "h1_title": "Fairbanks AK Apartments with Cedar Deck Porches",
      "h2_subtitle": "Explore Fairbanks AK apartments that feature charming cedar deck porches at Birchwood, offering a serene outdoor retreat.",
      "page_copy": "At Birchwood in Fairbanks, AK, our apartments feature delightful cedar deck porches that allow you to enjoy the stunning local scenery right from your doorstep. These porches are perfect for unwinding after a long day, providing a touch of rustic charm.\n\nIn addition to the beautiful outdoor spaces, Birchwood offers amenities such as basketball and tennis courts, and the convenience of on-site management and maintenance services. Our smoke-free community ensures a clean and healthy living environment. Choose Birchwood for a lifestyle that balances outdoor tranquility with modern conveniences in Fairbanks.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Deck Porches: Fairbanks AK Apartments",
      "seo_description": "Discover Birchwood in Fairbanks AK, where apartments come with inviting cedar deck porches and premium amenities in a smoke-free environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "generator",
      "page_item_url": "birchwood-dishwasher-equipped-apartments-99701",
      "search_query": "dishwasher equipped apartments near 99701",
      "category": "Amenity",
      "h1_title": "Dishwasher Equipped Apartments Near 99701",
      "h2_subtitle": "Find dishwasher equipped apartments near the 99701 area at Birchwood. Enjoy modern conveniences in a supportive community setting.",
      "page_copy": "Conveniently located near the 99701 area, Birchwood Apartments offer modern living with the added benefit of being equipped with dishwashers in select units. This crucial amenity simplifies daily routines, allowing more time to enjoy Birchwood's other standout features.\n\nResidents can take advantage of our basketball and tennis courts, as well as on-site management and maintenance, all within our welcoming, smoke-free community. Designed with comfort and ease in mind, Birchwood provides the ideal setting for those seeking a balanced and fulfilling lifestyle in Fairbanks, AK.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Birchwood Apartment: Dishwasher Equipped Near 99701",
      "seo_description": "Explore Birchwood Apartments near 99701. Enjoy dishwasher-equipped units and great amenities like sports courts in a smoke-free Fairbanks community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "generator",
      "page_item_url": "birchwood-large-closets-apartments-fairbanks",
      "search_query": "apartments with large closets fairbanks alaska",
      "category": "Amenity",
      "h1_title": "Apartments with Large Closets in Fairbanks, Alaska",
      "h2_subtitle": "Discover the convenience of apartments with large closets in Fairbanks, Alaska at Birchwood. Maximize your storage space without compromising on style.",
      "page_copy": "Nestled in Fairbanks, Alaska, Birchwood Apartments offer roomy closet spaces that make organizing your wardrobe a breeze. Our large closets provide ample storage, allowing you to maintain a tidy and clutter-free living area.\n\nBeyond spacious interiors, Birchwood boasts amenities that enhance your lifestyle, including basketball and tennis courts, and responsive on-site management. Our smoke-free community ensures a healthy living environment. Choose Birchwood if you value storage convenience coupled with an array of activities and services, right here in Fairbanks.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fairbanks Apartments with Large Closets | Birchwood",
      "seo_description": "Discover Birchwood in Fairbanks, Alaska. Enjoy spacious apartments with large closets and amenities like sports courts, all in a smoke-free environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "generator",
      "page_item_url": "birchwood-three-bedroom-apartments-fairbanks",
      "search_query": "three bedroom apartments fairbanks ak",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Fairbanks, AK",
      "h2_subtitle": "Explore spacious three bedroom apartments in Fairbanks, AK at Birchwood, perfect for families or those who need extra space.",
      "page_copy": "At Birchwood in Fairbanks, AK, our three bedroom apartments provide generous living spaces ideal for families or anyone who needs more room. Each unit is designed with comfort and functionality in mind, ensuring everyone can enjoy a personal sanctuary.\n\nOur vibrant community offers a variety of amenities, including basketball and tennis courts, to keep you active. With the added convenience of on-site management and maintenance, plus a smoke-free environment, Birchwood is the perfect place for those seeking a harmonious blend of comfort and community engagement in Fairbanks.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Three Bedroom Apartments in Fairbanks AK",
      "seo_description": "Find your ideal home in Fairbanks AK with Birchwood's three bedroom apartments featuring spacious layouts and great community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "generator",
      "page_item_url": "birchwood-four-bedroom-apartments-fairbanks-north-star",
      "search_query": "four bedroom apartments fairbanks north star borough",
      "category": "Floorplan",
      "h1_title": "Four Bedroom Apartments in Fairbanks North Star",
      "h2_subtitle": "Discover expansive four bedroom apartments in Fairbanks North Star Borough at Birchwood. Ideal for those seeking generous living spaces.",
      "page_copy": "Birchwood Apartments, located in the heart of Fairbanks North Star Borough, offers spacious four bedroom apartments perfect for families or households needing ample space. These oversized units provide flexibility and comfort, making them an ideal choice for larger families or groups.\n\nResidents of Birchwood enjoy more than just expansive living areas; our community features basketball and tennis courts, and offers smoke-free living. With on-site maintenance and management, residents can enjoy peace of mind and focus on making the most of their home and the vibrant Fairbanks community surrounding them.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Four Bedroom Apartments in Fairbanks North Star",
      "seo_description": "Explore four bedroom apartments at Birchwood in Fairbanks North Star Borough, offering spacious layouts and community amenities like sports courts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "generator",
      "page_item_url": "birchwood-five-bedroom-apartments-near-99701",
      "search_query": "five bedroom apartments near 99701",
      "category": "Floorplan",
      "h1_title": "Five Bedroom Apartments Near 99701 Area",
      "h2_subtitle": "Find ample space in five bedroom apartments near the 99701 area at Birchwood, where luxury and comfort go hand-in-hand.",
      "page_copy": "If you're looking for large, spacious accommodations near the 99701 area, Birchwood Apartments offers versatile five bedroom layouts perfect for large families or roommates. Designed with expansive living in mind, our five bedroom units allow everyone to find their own personal nook while enjoying shared spaces.\n\nSituated in the vibrant community of Fairbanks, Birchwood boasts amenities designed to enhance your living experience, such as full-size sports courts and a smoke-free policy. With attentive on-site management and maintenance, you can enjoy peace and privacy, knowing help is always nearby if needed.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Five Bedroom Apartments Near 99701 at Birchwood",
      "seo_description": "Discover spacious five bedroom apartments near the 99701 area. Enjoy ample living space with great amenities at Birchwood Apartments in Fairbanks.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "generator",
      "page_item_url": "birchwood-apartments-near-university-of-alaska-fairbanks",
      "search_query": "apartments near university of alaska fairbanks",
      "category": "School",
      "h1_title": "Apartments Near University of Alaska Fairbanks",
      "h2_subtitle": "Live close to campus with Birchwood's apartments near the University of Alaska Fairbanks, offering convenience and community.",
      "page_copy": "Convenience and community come together at Birchwood Apartments, located just a short distance from the University of Alaska Fairbanks. Ideal for students, faculty, and staff, these apartments provide easy access to campus while offering a peaceful retreat after a busy day.\n\nOur Fairbanks community features a range of amenities, including basketball and tennis courts, ensuring you stay active and engaged. Enjoy the benefits of on-site management and maintenance, and a smoke-free environment that contributes to a healthier, more enjoyable living experience. Choose Birchwood and find your perfect home base near the University of Alaska Fairbanks.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Birchwood: Apartments Near University of Alaska Fairbanks",
      "seo_description": "Find the ideal home base with Birchwood Apartments, conveniently located near the University of Alaska Fairbanks, offering top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "generator",
      "page_item_url": "birchwood-uaf-community-technical-college-apartments",
      "search_query": "uaf community and technical college nearby apartments fairbanks north star borough",
      "category": "School",
      "h1_title": "Apartments Near UAF Community & Tech College",
      "h2_subtitle": "Explore spacious living at Birchwood Apartments near UAF Community and Technical College in Fairbanks North Star Borough.",
      "page_copy": "Birchwood Apartments offers a convenient location for those connected with the UAF Community and Technical College. Situated within Fairbanks North Star Borough, our community provides an ideal setting for students, faculty, and staff seeking nearby accommodations.\n\nChoose from a variety of spacious layouts and enjoy our premium community amenities including tennis and basketball courts, as well as reliable on-site maintenance and management services. Birchwood's smoke-free environment ensures a healthy living atmosphere, making it a top choice for anyone looking to reside near UAF Community and Technical College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments - UAF Community & Technical College",
      "seo_description": "Discover Birchwood Apartments near UAF Community and Technical College, offering varied layouts and great amenities in Fairbanks North Star Borough.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "generator",
      "page_item_url": "birchwood-apartments-near-fairbanks-memorial-hospital",
      "search_query": "apartments near Fairbanks Memorial Hospital AK",
      "category": "Hospital",
      "h1_title": "Apartments Near Fairbanks Memorial Hospital AK",
      "h2_subtitle": "Discover the comfort of living close to work with our Birchwood apartments near Fairbanks Memorial Hospital, AK, in a welcoming community.",
      "page_copy": "Located close to Fairbanks Memorial Hospital, Birchwood Apartments provide an ideal home base for healthcare professionals and hospital visitors. Our community in Fairbanks offers convenient access to the hospital while providing a tranquil residential setting.\n\nEnjoy the benefits of Birchwood's amenities like tennis and basketball courts and the assurance of on-site management. Our smoke-free policy promotes a healthier living environment, making it the perfect choice for those seeking proximity to Fairbanks Memorial Hospital without compromising on lifestyle and comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Birchwood: Apartments Near Fairbanks Memorial Hospital AK",
      "seo_description": "Find comfort and convenience at Birchwood Apartments near Fairbanks Memorial Hospital, AK. Enjoy excellent amenities and a welcoming community in Fairbanks.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "generator",
      "page_item_url": "birchwood-apartments-near-bassett-community-hospital",
      "search_query": "Birchwood apartments close to Bassett Army Community Hospital Fairbanks North Star Borough",
      "category": "Hospital",
      "h1_title": "Birchwood Apartments Near Bassett Army Hospital",
      "h2_subtitle": "Experience convenient living at Birchwood Apartments, close to Bassett Army Community Hospital in Fairbanks North Star Borough.",
      "page_copy": "For those working at or visiting Bassett Army Community Hospital, Birchwood Apartments offer an ideal living solution within Fairbanks North Star Borough. Proximity to the hospital ensures a stress-free commute, allowing more time to relax and unwind.\n\nOur community is equipped with appealing features like tennis and basketball courts, along with the peace of mind that comes from on-site management and maintenance. Residents also appreciate the smoke-free environment, creating a welcoming and healthy atmosphere. Choose Birchwood Apartments for a comfortable lifestyle close to work at Bassett Army Community Hospital.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Birchwood: Apartments by Bassett Army Hospital",
      "seo_description": "Live near Bassett Army Community Hospital at Birchwood Apartments. Enjoy a convenient location with amenities in Fairbanks North Star Borough.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "generator",
      "page_item_url": "birchwood-apartments-near-pioneer-park-fairbanks",
      "search_query": "apartments near Pioneer Park Fairbanks",
      "category": "Park",
      "h1_title": "Apartments Near Pioneer Park in Fairbanks",
      "h2_subtitle": "Explore Birchwood Apartments, ideally situated near Pioneer Park in Fairbanks, offering a unique blend of comfort and convenience.",
      "page_copy": "Located just a short distance from Pioneer Park, Birchwood Apartments offer a vibrant living experience in Fairbanks. Perfect for adventure seekers and those who enjoy the outdoors, our residence provides easy access to the park’s attractions and natural beauty.\n\nEnjoy our community amenities like basketball and tennis courts or the peace of a smoke-free environment, all while being close to Fairbanks' landmark, Pioneer Park. Birchwood Apartments are designed to offer the perfect balance between leisure and lifestyle in a prime location.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Birchwood: Apartments Near Pioneer Park Fairbanks",
      "seo_description": "Find comfort and convenience near Pioneer Park at Birchwood Apartments in Fairbanks. Enjoy easy access to attractions and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "generator",
      "page_item_url": "birchwood-apartments-near-georgeson-botanical-garden",
      "search_query": "Birchwood apartments close to Georgeson Botanical Garden",
      "category": "Park",
      "h1_title": "Birchwood Apartments Near Georgeson Botanical Garden",
      "h2_subtitle": "Discover tranquil living at Birchwood Apartments, conveniently located close to Georgeson Botanical Garden in Fairbanks.",
      "page_copy": "Embrace nature's beauty at Birchwood Apartments, a short drive from the serene Georgeson Botanical Garden. Our location in Fairbanks offers a peaceful retreat for those who cherish the outdoors and botanical wonders.\n\nResidents of Birchwood enjoy amenities such as tennis courts, basketball courts, and a smoke-free environment, all contributing to a refreshing lifestyle. With on-site management and maintenance, choose Birchwood Apartments for a harmonious blend of comfort and nature near the Georgeson Botanical Garden.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Birchwood: Apartments by Georgeson Botanical Garden",
      "seo_description": "Experience lifestyle and convenience at Birchwood Apartments, near Georgeson Botanical Garden in Fairbanks. Ideal for nature enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167175",
      "source": "generator",
      "page_item_url": "rentals-near-museum-of-north-reichardt-park",
      "search_query": "Fairbanks North Star Borough rentals by Museum of the North/Reichardt Park",
      "category": "Park",
      "h1_title": "Rentals by Museum of the North in Fairbanks",
      "h2_subtitle": "Explore Birchwood Apartments for Fairbanks rentals near the Museum of the North and Reichardt Park, offering convenience and culture.",
      "page_copy": "Located within proximity to the Museum of the North and Reichardt Park, Birchwood Apartments offer an exceptional rental experience in Fairbanks North Star Borough. Ideal for culture enthusiasts and park-goers, this community provides easy access to both educational and recreational activities.\n\nOur residents benefit from a variety of amenities including two tennis courts, basketball courts, and the convenience of on-site management, all within a smoke-free environment. Birchwood Apartments combine comfort with culture, providing the perfect place to settle in Fairbanks near these prominent landmarks.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fairbanks Rentals Near Museum of the North",
      "seo_description": "Find comfort at Birchwood Apartments, offering rentals near the Museum of the North and Reichardt Park in Fairbanks North Star Borough.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2099"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309431248"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9075315282"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TN4Z6RK3"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "f8c5df2d-d49a-4550-a429-6c639c96ea4c"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/d6e33ce8-931a-4a01-bde8-59823fd7e7f7/app.js?property=d6e33ce8-931a-4a01-bde8-59823fd7e7f7&propertyName=Birchwood+Homes&channelUuid=c24911f4-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Imw2Sy9nOUd0cjk2RVZSZVdLdHhFb2c9PSIsInZhbHVlIjoib0RUYTc0WGZWSWVIcVlxWEpRdzFJZz09IiwibWFjIjoiNzk4NzUyZDU2NTRhMmYwOTU0YzUyNjU3NDNmMTFkZTJlMDYyOWZjMzkwYmMyOGU3YTM1OTYzNTA4MmVjZTVkNSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "2099",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309431248",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=9075315282",
  "custom_google_gtm_id": "GTM-TN4Z6RK3",
  "custom_rollout_phase": "Phase 8",
  "custom_rentgrata_token": "f8c5df2d-d49a-4550-a429-6c639c96ea4c",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/d6e33ce8-931a-4a01-bde8-59823fd7e7f7/app.js?property=d6e33ce8-931a-4a01-bde8-59823fd7e7f7&propertyName=Birchwood+Homes&channelUuid=c24911f4-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Imw2Sy9nOUd0cjk2RVZSZVdLdHhFb2c9PSIsInZhbHVlIjoib0RUYTc0WGZWSWVIcVlxWEpRdzFJZz09IiwibWFjIjoiNzk4NzUyZDU2NTRhMmYwOTU0YzUyNjU3NDNmMTFkZTJlMDYyOWZjMzkwYmMyOGU3YTM1OTYzNTA4MmVjZTVkNSJ9",
  "custom_audioeye_site_id": "2306da88-a6e5-4837-bcfe-91bb76f6635a",
  "custom_audioeye_site_hash": "2edb42bab999e643408657ce6c15670a"
};

export const generatedAt = '2026-11-04T23:47:19.865Z';
